import React from 'react';

interface ReadOnlyGraphProps {
  className: string;
}

/**
 * ReadOnlyGraph
 */
function ReadOnlyGraph({ className }: ReadOnlyGraphProps) {
  return (
    <svg
      width='732'
      height='459'
      viewBox='0 0 732 459'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}>
      <g clipPath='url(#clip0_11095_354993)'>
        <rect
          width='756'
          height='379'
          transform='translate(52 36.5)'
          fill='#0D0F1C'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M383.428 299.478C398.149 293.306 413.912 290.088 429.842 290.002C429.947 290.001 430.053 290.001 430.158 290C430.272 290 430.386 290 430.5 290C446.595 290 462.532 293.197 477.409 299.41C477.464 299.432 477.518 299.455 477.572 299.478C477.609 299.493 477.646 299.509 477.684 299.525C492.563 305.781 506.083 314.935 517.476 326.467C517.533 326.525 517.589 326.582 517.646 326.639C517.717 326.711 517.788 326.784 517.859 326.856C529.1 338.336 538.026 351.922 544.138 366.858C544.174 366.945 544.209 367.033 544.245 367.12C544.282 367.212 544.319 367.303 544.356 367.394C550.374 382.297 553.48 398.241 553.5 414.343C553.5 414.395 553.5 414.448 553.5 414.5H552.5C552.5 398.281 549.344 382.221 543.212 367.237C537.081 352.252 528.094 338.638 516.765 327.17C505.436 315.702 491.987 306.606 477.185 300.4C462.384 294.194 446.52 291 430.5 291C414.48 291 398.616 294.194 383.815 300.4C369.013 306.606 355.564 315.702 344.235 327.17C332.906 338.638 323.919 352.253 317.788 367.237C311.656 382.221 308.5 398.281 308.5 414.5H307.5C307.5 414.448 307.5 414.396 307.5 414.344C307.52 398.369 310.577 382.55 316.502 367.749C316.538 367.658 316.574 367.567 316.611 367.477C316.694 367.27 316.778 367.064 316.862 366.858C322.884 352.141 331.639 338.734 342.648 327.362C342.719 327.29 342.789 327.217 342.859 327.145C343.08 326.918 343.301 326.693 343.524 326.467C354.699 315.155 367.922 306.131 382.467 299.886C382.557 299.847 382.648 299.808 382.739 299.769C382.968 299.671 383.198 299.574 383.428 299.478Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M368.123 264.369C387.682 256.293 408.631 252.093 429.797 252.002C429.932 252.001 430.068 252.001 430.203 252C430.302 252 430.401 252 430.5 252C451.601 252 472.498 256.084 492.033 264.024C492.153 264.073 492.274 264.122 492.395 264.171C492.555 264.237 492.716 264.303 492.877 264.369C512.405 272.433 530.172 284.206 545.189 299.03C545.283 299.123 545.377 299.216 545.472 299.31C545.567 299.405 545.663 299.5 545.758 299.595C560.779 314.57 572.718 332.327 580.905 351.866C580.956 351.986 581.006 352.107 581.056 352.227C581.068 352.256 581.08 352.285 581.092 352.313C589.258 371.966 593.473 393.025 593.5 414.296C593.5 414.364 593.5 414.432 593.5 414.5H592.5C592.5 414.432 592.5 414.364 592.5 414.297C592.473 393.158 588.284 372.228 580.169 352.697C580.157 352.668 580.144 352.639 580.132 352.609C580.082 352.489 580.032 352.37 579.982 352.25C571.846 332.832 559.98 315.185 545.052 300.303C544.956 300.207 544.86 300.112 544.764 300.016C544.67 299.923 544.576 299.83 544.482 299.738C529.559 285.007 511.903 273.308 492.495 265.294C492.334 265.227 492.172 265.161 492.01 265.094C491.891 265.045 491.771 264.996 491.651 264.948C472.238 257.059 451.47 253 430.5 253C430.401 253 430.301 253 430.202 253C430.067 253.001 429.933 253.001 429.798 253.002C408.762 253.092 387.943 257.267 368.505 265.294C368.501 265.295 368.498 265.297 368.494 265.298C368.375 265.347 368.255 265.397 368.136 265.446C348.656 273.547 330.95 285.365 316.015 300.236C315.993 300.258 315.97 300.281 315.948 300.303C315.877 300.373 315.807 300.444 315.736 300.515C300.817 315.443 288.972 333.139 280.87 352.604C280.857 352.635 280.844 352.666 280.831 352.697C280.795 352.785 280.758 352.874 280.721 352.962C272.678 372.418 268.527 393.254 268.5 414.298C268.5 414.365 268.5 414.433 268.5 414.5H267.5C267.5 414.432 267.5 414.364 267.5 414.297C267.527 393.122 271.704 372.157 279.797 352.58C279.834 352.491 279.871 352.402 279.908 352.313C279.921 352.282 279.934 352.251 279.947 352.22C288.099 332.634 300.017 314.829 315.028 299.808C315.099 299.737 315.171 299.666 315.242 299.595C315.264 299.572 315.287 299.55 315.309 299.528C330.336 284.564 348.151 272.674 367.752 264.523C367.872 264.473 367.992 264.424 368.112 264.374C368.116 264.372 368.119 264.371 368.123 264.369Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M352.816 227.414C352.822 227.412 352.828 227.409 352.835 227.406C377.227 217.331 403.353 212.099 429.749 212.001C429.916 212.001 430.084 212 430.251 212C430.334 212 430.417 212 430.5 212C456.843 212 482.931 217.115 507.31 227.055C507.461 227.117 507.611 227.178 507.762 227.24C507.903 227.298 508.044 227.356 508.184 227.414C532.551 237.482 554.715 252.19 573.439 270.711C573.556 270.827 573.673 270.943 573.79 271.06C573.874 271.143 573.958 271.227 574.042 271.31C592.763 289.985 607.639 312.13 617.836 336.498C617.899 336.649 617.962 336.8 618.024 336.95C618.032 336.969 618.04 336.988 618.047 337.006C628.217 361.497 633.467 387.741 633.5 414.248C633.5 414.332 633.5 414.416 633.5 414.5H632.5C632.5 414.416 632.5 414.333 632.5 414.249C632.467 387.873 627.243 361.759 617.124 337.39C617.116 337.371 617.108 337.351 617.1 337.332C617.038 337.182 616.975 337.032 616.913 336.883C606.766 312.635 591.964 290.6 573.336 272.018C573.252 271.934 573.167 271.85 573.082 271.766C572.966 271.65 572.849 271.535 572.733 271.419C554.102 252.99 532.048 238.357 507.802 228.338C507.661 228.28 507.519 228.222 507.378 228.164C507.228 228.102 507.078 228.041 506.928 227.98C482.67 218.089 456.712 213 430.5 213C430.417 213 430.333 213 430.25 213C430.083 213 429.917 213.001 429.75 213.001C403.485 213.099 377.488 218.305 353.217 228.33C353.21 228.333 353.204 228.336 353.198 228.338C353.055 228.397 352.912 228.457 352.769 228.516C328.474 238.62 306.392 253.363 287.765 271.918C287.731 271.951 287.698 271.985 287.664 272.018C287.582 272.1 287.5 272.182 287.418 272.265C268.815 290.885 254.045 312.957 243.94 337.237C243.918 337.288 243.897 337.339 243.876 337.39C243.835 337.488 243.795 337.587 243.754 337.685C233.715 361.971 228.533 387.98 228.5 414.25C228.5 414.333 228.5 414.417 228.5 414.5H227.5C227.5 414.416 227.5 414.333 227.5 414.249C227.533 387.849 232.741 361.709 242.83 337.303C242.871 337.204 242.912 337.105 242.953 337.006C242.974 336.955 242.995 336.904 243.016 336.853C253.172 312.453 268.015 290.271 286.71 271.558C286.792 271.476 286.875 271.393 286.958 271.31C286.991 271.277 287.025 271.243 287.059 271.21C305.778 252.563 327.97 237.747 352.385 227.593C352.528 227.533 352.672 227.474 352.816 227.414Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M337.508 190.459C337.525 190.452 337.541 190.445 337.558 190.439C366.78 178.367 398.08 172.105 429.701 172.001C429.9 172.001 430.1 172 430.299 172C430.366 172 430.433 172 430.5 172C462.085 172 493.364 178.145 522.587 190.087C522.768 190.161 522.949 190.235 523.129 190.31C523.25 190.359 523.371 190.409 523.492 190.459C552.697 202.531 579.258 220.173 601.689 242.393C601.829 242.531 601.969 242.67 602.109 242.809C602.181 242.882 602.254 242.954 602.327 243.026C624.746 265.399 642.56 291.934 654.766 321.131C654.842 321.312 654.917 321.492 654.992 321.673C654.995 321.682 654.999 321.69 655.003 321.699C667.176 351.028 673.46 382.456 673.5 414.2C673.5 414.3 673.5 414.4 673.5 414.5H672.5C672.5 414.4 672.5 414.301 672.5 414.201C672.461 382.589 666.202 351.29 654.079 322.082C654.075 322.073 654.071 322.064 654.068 322.055C653.993 321.875 653.918 321.695 653.843 321.515C641.687 292.439 623.947 266.015 601.62 243.734C601.547 243.661 601.474 243.588 601.401 243.515C601.262 243.377 601.122 243.239 600.983 243.101C578.645 220.974 552.194 203.405 523.11 191.383C522.988 191.333 522.867 191.283 522.745 191.233C522.565 191.159 522.385 191.085 522.206 191.012C493.103 179.119 461.954 173 430.5 173C430.433 173 430.365 173 430.298 173C430.099 173 429.901 173.001 429.702 173.001C398.211 173.105 367.041 179.341 337.94 191.363C337.923 191.37 337.907 191.376 337.89 191.383C337.727 191.451 337.565 191.518 337.402 191.586C308.292 203.693 281.833 221.362 259.515 243.6C259.47 243.644 259.425 243.689 259.38 243.734C259.286 243.827 259.193 243.921 259.099 244.014C236.814 266.327 219.118 292.776 207.009 321.87C206.98 321.941 206.95 322.012 206.921 322.082C206.876 322.191 206.831 322.299 206.786 322.408C194.751 351.523 188.539 382.707 188.5 414.202C188.5 414.302 188.5 414.401 188.5 414.5H187.5C187.5 414.4 187.5 414.301 187.5 414.201C187.539 382.575 193.777 351.262 205.862 322.026C205.907 321.917 205.952 321.808 205.997 321.699C206.027 321.628 206.056 321.557 206.086 321.486C218.245 292.271 236.014 265.713 258.391 243.308C258.485 243.214 258.579 243.12 258.673 243.026C258.718 242.981 258.763 242.936 258.808 242.892C281.22 220.562 307.788 202.82 337.018 190.662C337.181 190.595 337.345 190.527 337.508 190.459Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M322.2 152.58C356.274 138.441 392.776 131.112 429.652 131.001C429.884 131.001 430.116 131 430.348 131C430.398 131 430.449 131 430.5 131C467.445 131 504.03 138.247 538.191 152.329C538.394 152.412 538.597 152.496 538.8 152.58C538.808 152.584 538.816 152.587 538.825 152.591C573.012 166.78 604.088 187.549 630.294 213.718C630.4 213.824 630.506 213.93 630.612 214.036C630.668 214.092 630.725 214.149 630.781 214.206C656.903 240.418 677.645 271.505 691.833 305.707C691.875 305.808 691.916 305.909 691.958 306.01C692.004 306.12 692.049 306.23 692.095 306.34C706.183 340.534 713.455 377.16 713.5 414.152C713.5 414.268 713.5 414.384 713.5 414.5H712.5C712.5 414.384 712.5 414.269 712.5 414.154C712.455 377.292 705.209 340.796 691.17 306.722C691.125 306.612 691.079 306.502 691.034 306.392C690.993 306.292 690.951 306.192 690.91 306.092C676.771 272.009 656.103 241.032 630.073 214.912C630.017 214.855 629.96 214.799 629.904 214.742C629.799 214.637 629.694 214.532 629.588 214.426C603.474 188.349 572.507 167.653 538.44 153.514C538.432 153.511 538.424 153.507 538.416 153.504C538.214 153.42 538.012 153.336 537.81 153.253C503.769 139.221 467.314 132 430.5 132C430.449 132 430.398 132 430.346 132C430.116 132 429.885 132.001 429.654 132.001C392.909 132.112 356.537 139.415 322.584 153.504C322.501 153.538 322.419 153.572 322.337 153.607C322.127 153.694 321.917 153.781 321.708 153.869C287.839 168.057 257.059 188.734 231.096 214.742C231.035 214.804 230.973 214.866 230.911 214.927C230.75 215.089 230.589 215.251 230.429 215.413C204.557 241.505 184.017 272.409 169.966 306.392C169.959 306.41 169.951 306.428 169.943 306.446C169.857 306.656 169.77 306.866 169.684 307.075C155.741 341.048 148.545 377.42 148.5 414.155C148.5 414.27 148.5 414.385 148.5 414.5H147.5C147.5 414.384 147.5 414.269 147.5 414.154C147.545 377.288 154.767 340.787 168.76 306.693C168.847 306.483 168.933 306.273 169.02 306.062C169.027 306.045 169.035 306.027 169.042 306.01C183.143 271.906 203.756 240.891 229.721 214.707C229.882 214.544 230.044 214.382 230.205 214.219C230.266 214.158 230.327 214.097 230.388 214.036C256.443 187.934 287.334 167.184 321.323 152.946C321.534 152.858 321.744 152.77 321.955 152.682C322.037 152.648 322.118 152.614 322.2 152.58Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M306.893 115.625C345.805 99.482 387.492 91.1182 429.605 91.0012C429.868 91.0005 430.132 91.0001 430.395 91C430.43 91 430.465 91 430.5 91C472.687 91 514.463 99.277 553.469 115.361C553.681 115.449 553.894 115.537 554.107 115.625C554.135 115.637 554.163 115.648 554.192 115.66C593.194 131.853 628.646 155.547 658.545 185.4C658.662 185.517 658.779 185.634 658.896 185.751C658.964 185.819 659.032 185.887 659.1 185.956C688.905 215.86 712.572 251.323 728.763 290.34C728.813 290.461 728.863 290.581 728.913 290.702C728.963 290.822 729.013 290.943 729.062 291.063C745.146 330.087 753.448 371.887 753.5 414.105C753.5 414.236 753.5 414.368 753.5 414.5H752.5C752.5 414.369 752.5 414.237 752.5 414.106C752.448 372.018 744.172 330.348 728.138 291.445C728.089 291.325 728.039 291.205 727.989 291.084C727.94 290.964 727.89 290.844 727.84 290.724C711.698 251.827 688.105 216.474 658.392 186.662C658.324 186.594 658.256 186.526 658.188 186.458C658.072 186.341 657.955 186.225 657.838 186.108C628.032 156.347 592.689 132.727 553.807 116.583C553.78 116.572 553.752 116.56 553.724 116.549C553.512 116.461 553.299 116.373 553.087 116.285C514.202 100.251 472.556 92 430.5 92C430.465 92 430.429 92 430.394 92C430.131 92.0001 429.869 92.0005 429.606 92.0012C387.624 92.118 346.068 100.456 307.276 116.549C307.204 116.579 307.132 116.609 307.059 116.639C306.82 116.738 306.58 116.838 306.34 116.939C267.642 133.136 232.473 156.75 202.812 186.458C202.762 186.508 202.711 186.559 202.661 186.609C202.477 186.793 202.294 186.978 202.11 187.163C172.542 216.961 149.068 252.26 133.013 291.079L133.011 291.084C132.913 291.322 132.814 291.56 132.717 291.798C116.778 330.601 108.551 372.147 108.5 414.107C108.5 414.238 108.5 414.369 108.5 414.5H107.5C107.5 414.369 107.5 414.237 107.5 414.106C107.551 372.015 115.804 330.339 131.792 291.416C131.89 291.178 131.988 290.94 132.087 290.702C132.088 290.7 132.089 290.697 132.09 290.695C148.195 251.756 171.741 216.347 201.402 186.456C201.586 186.271 201.77 186.086 201.955 185.901C202.005 185.851 202.054 185.801 202.104 185.751C231.858 155.951 267.137 132.263 305.956 116.015C306.196 115.915 306.437 115.815 306.678 115.715C306.749 115.685 306.821 115.655 306.893 115.625Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M290.895 78.6698C334.996 60.4022 382.264 51 430 51C477.736 51 525.004 60.4022 569.105 78.6698C613.207 96.9374 653.279 123.713 687.033 157.467C720.787 191.221 747.563 231.293 765.83 275.395C784.098 319.496 793.5 366.764 793.5 414.5H792.5C792.5 414.353 792.5 414.205 792.5 414.058C792.442 366.75 783.125 319.91 765.073 276.181C765.018 276.047 764.962 275.912 764.906 275.777C764.85 275.642 764.794 275.506 764.738 275.371C746.581 231.686 720.048 191.977 686.637 158.485C686.533 158.381 686.43 158.277 686.326 158.174C686.223 158.07 686.119 157.967 686.015 157.863C652.523 124.452 612.814 97.9194 569.129 79.7623C568.994 79.706 568.858 79.6498 568.723 79.5937C568.588 79.5379 568.453 79.4822 568.319 79.4266C524.59 61.3752 477.75 52.0579 430.442 52.0003C430.295 52.0001 430.147 52 430 52C429.853 52 429.705 52.0001 429.558 52.0003C382.25 52.0579 335.41 61.3752 291.681 79.4266C291.547 79.4822 291.412 79.5379 291.277 79.5937C291.142 79.6498 291.006 79.706 290.871 79.7623C247.186 97.9194 207.477 124.452 173.985 157.863C173.881 157.967 173.777 158.07 173.674 158.174C173.57 158.277 173.467 158.381 173.363 158.485C139.952 191.977 113.419 231.686 95.2623 275.371C95.206 275.506 95.1498 275.642 95.0937 275.777C95.0379 275.912 94.9822 276.047 94.9266 276.181C76.8752 319.91 67.5579 366.75 67.5003 414.058C67.5001 414.205 67.5 414.353 67.5 414.5H66.5C66.5 366.765 75.9022 319.496 94.1698 275.395C112.437 231.293 139.213 191.221 172.967 157.467C206.721 123.713 246.793 96.9374 290.895 78.6698Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M793 414.943L552 414.655L552 414.5L552 414.345L553.5 414.343L592.5 414.297L593.5 414.296L632.5 414.249L633.5 414.248L672.5 414.201L673.5 414.2L712.5 414.154L713.5 414.152L752.5 414.106L753.5 414.105L792.5 414.058L793 414.057C793 414.205 793 414.352 793 414.5C793 414.648 793 414.795 793 414.943ZM765.623 275.954L765.073 276.181L729.062 291.063L728.138 291.445L692.095 306.34L691.17 306.722L654.992 321.673L654.068 322.055L618.024 336.95L617.1 337.332L581.056 352.227L580.132 352.609L544.356 367.394L542.893 367.999C542.856 367.909 542.819 367.819 542.781 367.729L544.245 367.12L579.982 352.25L580.905 351.866L616.913 336.883L617.836 336.498L653.843 321.515L654.766 321.131L690.91 306.092L691.833 305.707L727.84 290.724L728.763 290.34L764.738 275.371L765.287 275.142C765.399 275.413 765.512 275.683 765.623 275.954ZM686.991 158.132L686.637 158.485L659.1 185.956L658.392 186.662L630.781 214.206L630.073 214.912L602.109 242.809L601.401 243.515L573.79 271.06L573.082 271.766L545.472 299.31L544.764 300.016L517.859 326.856L516.373 328.339C516.302 328.268 516.232 328.198 516.161 328.127L517.646 326.639L544.482 299.738L545.189 299.03L572.733 271.419L573.439 270.711L600.983 243.101L601.689 242.393L629.588 214.426L630.294 213.718L657.838 186.108L658.545 185.4L686.015 157.863L686.368 157.509C686.576 157.716 686.784 157.924 686.991 158.132ZM569.358 79.2132L569.129 79.7623L554.192 115.66L553.807 116.583L538.825 152.591L538.44 153.514L523.129 190.31L522.745 191.233L507.762 227.24L507.378 228.164L492.395 264.171L492.01 265.094L477.684 299.525L476.771 301.719C476.681 301.681 476.591 301.644 476.501 301.607L477.409 299.41L491.651 264.948L492.033 264.024L506.928 227.98L507.31 227.055L522.206 191.012L522.587 190.087L537.81 153.253L538.191 152.329L553.087 116.285L553.469 115.361L568.319 79.4266L568.546 78.8766C568.817 78.9885 569.087 79.1007 569.358 79.2132ZM430.443 51.5003L430.442 52.0003L430.395 91L430.394 92L430.348 131L430.346 132L430.299 172L430.298 173L430.251 212L430.25 213L430.203 252L430.202 253L430.158 290L430.155 292.5L430 292.5L429.845 292.5L429.842 290.002L429.798 253.002L429.797 252.002L429.75 213.001L429.749 212.001L429.702 173.001L429.701 172.001L429.654 132.001L429.652 131.001L429.606 92.0012L429.605 91.0012L429.558 52.0003L429.558 51.5003C429.705 51.5001 429.852 51.5 430 51.5C430.148 51.5 430.295 51.5001 430.443 51.5003ZM291.454 78.8766L291.681 79.4266L306.678 115.715L307.059 116.639L321.955 152.682L322.337 153.607L337.558 190.439L337.94 191.363L352.835 227.406L353.217 228.33L368.112 264.374L368.494 265.298L382.739 299.769L383.499 301.607C383.409 301.644 383.319 301.681 383.229 301.719L382.467 299.886L368.136 265.446L367.752 264.523L352.769 228.516L352.385 227.593L337.402 191.586L337.018 190.662L321.708 153.869L321.323 152.946L306.34 116.939L305.956 116.015L290.871 79.7623L290.642 79.2132C290.913 79.1006 291.183 78.9884 291.454 78.8766ZM173.632 157.509L173.985 157.863L201.955 185.901L202.661 186.609L230.205 214.219L230.911 214.927L258.808 242.892L259.515 243.6L287.059 271.21L287.765 271.918L315.309 299.528L316.015 300.236L342.859 327.145L343.839 328.127C343.768 328.198 343.698 328.268 343.627 328.339L342.648 327.362L315.736 300.515L315.028 299.808L287.418 272.265L286.71 271.558L259.099 244.014L258.391 243.308L230.429 215.413L229.721 214.707L202.11 187.163L201.402 186.456L173.363 158.485L173.009 158.132C173.216 157.924 173.424 157.716 173.632 157.509ZM94.7132 275.142L95.2623 275.371L132.09 290.695L133.013 291.079L169.02 306.062L169.943 306.446L206.086 321.486L207.009 321.87L243.016 336.853L243.94 337.237L279.947 352.22L280.87 352.604L316.611 367.477L317.219 367.729C317.181 367.819 317.144 367.909 317.107 367.999L316.502 367.749L280.721 352.962L279.797 352.58L243.754 337.685L242.83 337.303L206.786 322.408L205.862 322.026L169.684 307.075L168.76 306.693L132.717 291.798L131.792 291.416L94.9266 276.181L94.3766 275.954C94.4885 275.683 94.6007 275.413 94.7132 275.142ZM67.0003 414.057C67.0001 414.205 67 414.352 67 414.5C67 414.648 67.0001 414.795 67.0003 414.942L308 414.655L308 414.5L308 414.345L307.5 414.344L268.5 414.298L267.5 414.297L228.5 414.25L227.5 414.249L188.5 414.202L187.5 414.201L148.5 414.155L147.5 414.154L108.5 414.107L107.5 414.106L67.5003 414.058L67.0003 414.057Z'
          fill='#4A4C59'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M431 320.5C430.452 320.5 429.905 320.505 429.359 320.515L428.986 300.519C429.656 300.506 430.327 300.5 431 300.5C431.673 300.5 432.344 300.506 433.014 300.519L432.641 320.515C432.095 320.505 431.548 320.5 431 320.5ZM426.097 320.637C425.005 320.698 423.918 320.779 422.837 320.881L420.969 300.968C422.3 300.843 423.636 300.743 424.979 300.668L426.097 320.637ZM439.163 320.881C438.082 320.779 436.995 320.698 435.903 320.637L437.021 300.668C438.364 300.743 439.7 300.843 441.031 300.968L439.163 320.881ZM445.634 321.735C444.565 321.552 443.49 321.39 442.408 321.247L445.026 301.419C446.357 301.595 447.682 301.795 448.998 302.02L445.634 321.735ZM419.592 321.247C418.51 321.39 417.435 321.553 416.366 321.735L413.002 302.02C414.318 301.795 415.643 301.595 416.974 301.419L419.592 321.247ZM452.02 323.076C450.966 322.812 449.905 322.568 448.837 322.344L452.946 302.771C454.262 303.047 455.569 303.348 456.867 303.672L452.02 323.076ZM413.163 322.344C412.095 322.568 411.034 322.812 409.98 323.076L405.133 303.672C406.431 303.348 407.738 303.047 409.054 302.771L413.163 322.344ZM458.285 324.895C457.255 324.553 456.216 324.23 455.17 323.926L460.749 304.72C462.038 305.094 463.317 305.492 464.586 305.914L458.285 324.895ZM406.83 323.926C405.784 324.23 404.745 324.553 403.715 324.895L397.414 305.914C398.683 305.492 399.962 305.094 401.251 304.72L406.83 323.926ZM464.402 327.185C463.398 326.765 462.385 326.364 461.364 325.982L468.375 307.251C469.632 307.722 470.877 308.215 472.112 308.731L464.402 327.185ZM400.636 325.982C399.615 326.364 398.602 326.765 397.598 327.185L389.888 308.731C391.123 308.215 392.368 307.722 393.625 307.251L400.636 325.982ZM470.333 329.928C469.363 329.434 468.382 328.958 467.393 328.501L475.787 310.348C477.003 310.91 478.207 311.494 479.398 312.1L470.333 329.928ZM394.607 328.501C393.618 328.958 392.637 329.434 391.667 329.928L382.602 312.1C383.793 311.494 384.997 310.91 386.213 310.348L394.607 328.501ZM476.053 333.108C475.119 332.542 474.175 331.995 473.222 331.464L482.941 313.985C484.11 314.635 485.266 315.306 486.409 315.998L476.053 333.108ZM388.778 331.464C387.825 331.995 386.881 332.543 385.947 333.108L375.591 315.998C376.734 315.306 377.89 314.635 379.059 313.985L388.778 331.464ZM481.529 336.703C480.638 336.07 479.736 335.454 478.823 334.855L489.8 318.136C490.917 318.87 492.02 319.623 493.108 320.396L481.529 336.703ZM383.177 334.855C382.264 335.454 381.362 336.07 380.471 336.703L368.892 320.396C369.98 319.623 371.083 318.87 372.2 318.136L383.177 334.855ZM377.832 338.65C376.964 339.315 376.108 339.995 375.264 340.692L362.536 325.265C363.566 324.415 364.61 323.585 365.669 322.773L377.832 338.65ZM486.736 340.692C485.892 339.995 485.036 339.315 484.168 338.65L496.331 322.773C497.39 323.585 498.434 324.415 499.464 325.265L486.736 340.692ZM372.77 342.826C371.951 343.552 371.145 344.294 370.352 345.05L356.553 330.573C357.518 329.653 358.499 328.75 359.497 327.866L372.77 342.826ZM491.648 345.05C490.855 344.294 490.049 343.552 489.23 342.826L502.503 327.866C503.501 328.75 504.482 329.653 505.447 330.573L491.648 345.05ZM368.014 347.359C367.249 348.142 366.497 348.94 365.759 349.751L350.968 336.289C351.865 335.303 352.778 334.334 353.709 333.382L368.014 347.359ZM496.241 349.751C495.503 348.94 494.751 348.142 493.986 347.359L508.291 333.382C509.222 334.334 510.135 335.303 511.032 336.289L496.241 349.751ZM363.588 352.222C362.879 353.058 362.184 353.908 361.504 354.77L345.802 342.382C346.628 341.336 347.471 340.305 348.331 339.29L363.588 352.222ZM500.496 354.77C499.816 353.908 499.121 353.058 498.412 352.222L513.669 339.29C514.529 340.305 515.372 341.336 516.198 342.382L500.496 354.77ZM359.511 357.389C358.863 358.273 358.229 359.169 357.611 360.077L341.082 348.817C341.831 347.717 342.599 346.63 343.385 345.559L359.511 357.389ZM504.389 360.077C503.771 359.169 503.137 358.273 502.489 357.389L518.615 345.559C519.401 346.63 520.169 347.717 520.918 348.817L504.389 360.077ZM507.907 365.648C507.352 364.698 506.782 363.759 506.196 362.831L523.107 352.154C523.817 353.278 524.508 354.415 525.179 355.566L507.907 365.648ZM355.804 362.831C355.218 363.759 354.648 364.698 354.093 365.648L336.821 355.566C337.492 354.415 338.183 353.278 338.893 352.154L355.804 362.831ZM511.028 371.449C510.541 370.463 510.037 369.486 509.517 368.521L527.129 359.043C527.758 360.212 528.368 361.393 528.958 362.587L511.028 371.449ZM352.483 368.521C351.963 369.486 351.459 370.463 350.972 371.449L333.042 362.587C333.632 361.393 334.242 360.212 334.871 359.043L352.483 368.521ZM513.744 377.458C513.325 376.439 512.89 375.429 512.438 374.43L530.663 366.192C531.21 367.402 531.736 368.623 532.243 369.855L513.744 377.458ZM349.562 374.43C349.11 375.429 348.675 376.439 348.256 377.458L329.757 369.855C330.264 368.623 330.79 367.402 331.337 366.192L349.562 374.43ZM516.039 383.638C515.691 382.592 515.326 381.555 514.944 380.527L533.693 373.565C534.155 374.808 534.596 376.061 535.016 377.324L516.039 383.638ZM347.056 380.527C346.674 381.555 346.309 382.592 345.961 383.638L326.984 377.324C327.404 376.061 327.845 374.808 328.307 373.565L347.056 380.527ZM517.906 389.966C517.63 388.899 517.337 387.839 517.027 386.788L536.21 381.129C536.585 382.4 536.939 383.679 537.271 384.968L517.906 389.966ZM344.973 386.788C344.663 387.839 344.37 388.899 344.094 389.967L324.729 384.968C325.061 383.679 325.415 382.4 325.79 381.129L344.973 386.788ZM519.337 396.41C519.134 395.325 518.914 394.246 518.676 393.174L538.2 388.839C538.487 390.132 538.753 391.434 538.997 392.743L519.337 396.41ZM343.324 393.174C343.086 394.246 342.866 395.325 342.663 396.41L323.003 392.743C323.247 391.434 323.513 390.132 323.8 388.839L343.324 393.174ZM520.327 402.94C520.198 401.843 520.052 400.753 519.887 399.669L539.661 396.67C539.859 397.976 540.036 399.29 540.191 400.61L520.327 402.94ZM342.113 399.669C341.948 400.753 341.802 401.843 341.673 402.94L321.809 400.61C321.964 399.29 322.141 397.976 322.339 396.67L342.113 399.669ZM341.343 406.23C341.252 407.326 341.178 408.428 341.123 409.535L321.148 408.541C321.214 407.211 321.302 405.887 321.412 404.569L341.343 406.23ZM520.877 409.535C520.822 408.428 520.748 407.326 520.657 406.23L540.588 404.569C540.698 405.887 540.786 407.211 540.852 408.541L520.877 409.535ZM341.014 412.838C341.005 413.391 341 413.945 341 414.5H321C321 413.834 321.006 413.17 321.017 412.506L341.014 412.838ZM521 414.5C521 413.945 520.995 413.391 520.986 412.838L540.983 412.506C540.994 413.17 541 413.834 541 414.5H521Z'
          fill='url(#paint0_linear_11095_354993)'
        />
        <path
          d='M35 414.18C35 414.268 34.976 414.336 34.928 414.384C34.872 414.432 34.804 414.456 34.724 414.456L26.888 414.456C26.8 414.456 26.732 414.432 26.684 414.384C26.628 414.336 26.6 414.268 26.6 414.18L26.6 411.252C26.6 410.348 26.812 409.632 27.236 409.104C27.66 408.576 28.288 408.312 29.12 408.312C29.736 408.312 30.24 408.468 30.632 408.78C31.016 409.084 31.284 409.5 31.436 410.028L34.628 408.18C34.676 408.156 34.72 408.144 34.76 408.144C34.824 408.144 34.88 408.172 34.928 408.228C34.976 408.276 35 408.332 35 408.396L35 408.972C35 409.108 34.964 409.208 34.892 409.272C34.82 409.336 34.748 409.392 34.676 409.44L31.628 411.18L31.628 413.28L34.724 413.28C34.804 413.28 34.872 413.308 34.928 413.364C34.976 413.412 35 413.48 35 413.568L35 414.18ZM30.608 413.28L30.608 411.3C30.608 410.7 30.484 410.252 30.236 409.956C29.98 409.66 29.604 409.512 29.108 409.512C28.62 409.512 28.248 409.66 27.992 409.956C27.736 410.244 27.608 410.692 27.608 411.3L27.608 413.28L30.608 413.28ZM35 406.473C35 406.553 34.976 406.621 34.928 406.677C34.872 406.725 34.804 406.749 34.724 406.749L29.036 406.749C28.956 406.749 28.892 406.725 28.844 406.677C28.788 406.621 28.76 406.553 28.76 406.473L28.76 405.897C28.76 405.817 28.788 405.753 28.844 405.705C28.892 405.657 28.956 405.633 29.036 405.633L34.724 405.633C34.804 405.633 34.872 405.657 34.928 405.705C34.976 405.753 35 405.817 35 405.897L35 406.473ZM27.596 406.569C27.596 406.649 27.572 406.717 27.524 406.773C27.468 406.821 27.4 406.845 27.32 406.845L26.672 406.845C26.592 406.845 26.528 406.821 26.48 406.773C26.424 406.717 26.396 406.649 26.396 406.569L26.396 405.813C26.396 405.733 26.424 405.669 26.48 405.621C26.528 405.565 26.592 405.537 26.672 405.537L27.32 405.537C27.4 405.537 27.468 405.565 27.524 405.621C27.572 405.669 27.596 405.733 27.596 405.813L27.596 406.569ZM35.12 401.682C35.12 402.13 35.064 402.514 34.952 402.834C34.84 403.154 34.704 403.414 34.544 403.614C34.384 403.814 34.224 403.966 34.064 404.07C33.904 404.166 33.776 404.218 33.68 404.226C33.592 404.234 33.524 404.206 33.476 404.142C33.428 404.078 33.404 404.014 33.404 403.95L33.404 403.422C33.404 403.374 33.412 403.338 33.428 403.314C33.436 403.282 33.468 403.242 33.524 403.194C33.636 403.09 33.748 402.974 33.86 402.846C33.972 402.718 34.064 402.562 34.136 402.378C34.208 402.186 34.244 401.95 34.244 401.67C34.244 401.262 34.168 400.926 34.016 400.662C33.856 400.398 33.624 400.266 33.32 400.266C33.12 400.266 32.96 400.322 32.84 400.434C32.72 400.538 32.612 400.73 32.516 401.01C32.42 401.282 32.32 401.658 32.216 402.138C32.104 402.618 31.968 402.998 31.808 403.278C31.64 403.558 31.444 403.758 31.22 403.878C30.988 403.998 30.728 404.058 30.44 404.058C30.144 404.058 29.86 403.97 29.588 403.794C29.308 403.618 29.08 403.362 28.904 403.026C28.728 402.682 28.64 402.254 28.64 401.742C28.64 401.326 28.692 400.97 28.796 400.674C28.9 400.378 29.032 400.134 29.192 399.942C29.344 399.75 29.496 399.606 29.648 399.51C29.8 399.414 29.928 399.362 30.032 399.354C30.112 399.346 30.18 399.37 30.236 399.426C30.284 399.482 30.308 399.546 30.308 399.618L30.308 400.122C30.308 400.178 30.296 400.226 30.272 400.266C30.248 400.298 30.22 400.33 30.188 400.362C30.084 400.442 29.98 400.538 29.876 400.65C29.772 400.754 29.688 400.894 29.624 401.07C29.552 401.238 29.516 401.462 29.516 401.742C29.516 402.142 29.6 402.442 29.768 402.642C29.936 402.842 30.148 402.942 30.404 402.942C30.556 402.942 30.692 402.898 30.812 402.81C30.932 402.722 31.04 402.554 31.136 402.306C31.232 402.058 31.336 401.69 31.448 401.202C31.552 400.674 31.692 400.258 31.868 399.954C32.044 399.65 32.248 399.434 32.48 399.306C32.712 399.178 32.98 399.114 33.284 399.114C33.62 399.114 33.928 399.214 34.208 399.414C34.488 399.606 34.712 399.894 34.88 400.278C35.04 400.654 35.12 401.122 35.12 401.682ZM35 397.437C35 397.517 34.976 397.585 34.928 397.641C34.872 397.689 34.804 397.713 34.724 397.713L26.756 397.713C26.676 397.713 26.612 397.689 26.564 397.641C26.508 397.585 26.48 397.517 26.48 397.437L26.48 396.873C26.48 396.793 26.508 396.729 26.564 396.681C26.612 396.625 26.676 396.597 26.756 396.597L30.932 396.597L28.964 394.233C28.884 394.137 28.832 394.065 28.808 394.017C28.776 393.961 28.76 393.873 28.76 393.753L28.76 393.117C28.76 393.045 28.784 392.985 28.832 392.937C28.88 392.889 28.94 392.865 29.012 392.865C29.044 392.865 29.08 392.877 29.12 392.901C29.16 392.917 29.2 392.953 29.24 393.009L31.544 395.781L34.532 392.709C34.612 392.613 34.684 392.565 34.748 392.565C34.82 392.565 34.88 392.589 34.928 392.637C34.976 392.685 35 392.745 35 392.817L35 393.441C35 393.561 34.988 393.649 34.964 393.705C34.932 393.761 34.876 393.833 34.796 393.921L32.24 396.597L34.724 396.597C34.804 396.597 34.872 396.625 34.928 396.681C34.976 396.729 35 396.793 35 396.873L35 397.437ZM35.12 385.858C35.12 386.554 35.016 387.138 34.808 387.61C34.592 388.082 34.316 388.446 33.98 388.702C33.636 388.95 33.272 389.082 32.888 389.098C32.824 389.098 32.768 389.074 32.72 389.026C32.664 388.97 32.636 388.906 32.636 388.834L32.636 388.222C32.636 388.126 32.66 388.054 32.708 388.006C32.756 387.958 32.812 387.926 32.876 387.91C33.068 387.87 33.26 387.774 33.452 387.622C33.636 387.462 33.792 387.242 33.92 386.962C34.04 386.674 34.1 386.306 34.1 385.858C34.1 385.17 33.98 384.666 33.74 384.346C33.492 384.018 33.164 383.854 32.756 383.854C32.476 383.854 32.252 383.942 32.084 384.118C31.908 384.286 31.752 384.546 31.616 384.898C31.48 385.25 31.332 385.706 31.172 386.266C31.004 386.85 30.82 387.334 30.62 387.718C30.42 388.102 30.172 388.39 29.876 388.582C29.58 388.766 29.204 388.858 28.748 388.858C28.316 388.858 27.932 388.742 27.596 388.51C27.252 388.278 26.98 387.946 26.78 387.514C26.58 387.074 26.48 386.542 26.48 385.918C26.48 385.422 26.548 384.99 26.684 384.622C26.812 384.246 26.988 383.934 27.212 383.686C27.428 383.438 27.664 383.25 27.92 383.122C28.168 382.994 28.412 382.926 28.652 382.918C28.708 382.918 28.764 382.938 28.82 382.978C28.868 383.018 28.892 383.082 28.892 383.17L28.892 383.806C28.892 383.862 28.876 383.922 28.844 383.986C28.812 384.042 28.752 384.086 28.664 384.118C28.336 384.166 28.06 384.35 27.836 384.67C27.612 384.99 27.5 385.406 27.5 385.918C27.5 386.438 27.6 386.862 27.8 387.19C28 387.51 28.312 387.67 28.736 387.67C29.008 387.67 29.236 387.594 29.42 387.442C29.596 387.29 29.752 387.05 29.888 386.722C30.024 386.394 30.168 385.966 30.32 385.438C30.496 384.798 30.684 384.274 30.884 383.866C31.076 383.458 31.32 383.158 31.616 382.966C31.904 382.766 32.276 382.666 32.732 382.666C33.236 382.666 33.668 382.798 34.028 383.062C34.38 383.326 34.652 383.698 34.844 384.178C35.028 384.65 35.12 385.21 35.12 385.858ZM35.12 378.729C35.12 379.297 35.012 379.789 34.796 380.205C34.572 380.613 34.256 380.929 33.848 381.153C33.432 381.377 32.936 381.497 32.36 381.513C32.24 381.521 32.08 381.525 31.88 381.525C31.68 381.525 31.52 381.521 31.4 381.513C30.824 381.497 30.332 381.377 29.924 381.153C29.508 380.929 29.192 380.613 28.976 380.205C28.752 379.789 28.64 379.297 28.64 378.729C28.64 378.265 28.704 377.869 28.832 377.541C28.96 377.205 29.124 376.929 29.324 376.713C29.524 376.497 29.74 376.337 29.972 376.233C30.204 376.121 30.424 376.061 30.632 376.053C30.712 376.045 30.776 376.069 30.824 376.125C30.872 376.181 30.896 376.249 30.896 376.329L30.896 376.905C30.896 376.985 30.88 377.045 30.848 377.085C30.808 377.125 30.744 377.165 30.656 377.205C30.264 377.349 29.988 377.545 29.828 377.793C29.668 378.041 29.588 378.349 29.588 378.717C29.588 379.197 29.736 379.589 30.032 379.893C30.328 380.189 30.804 380.349 31.46 380.373C31.748 380.381 32.028 380.381 32.3 380.373C32.964 380.349 33.444 380.189 33.74 379.893C34.028 379.589 34.172 379.197 34.172 378.717C34.172 378.349 34.092 378.041 33.932 377.793C33.772 377.545 33.496 377.349 33.104 377.205C33.016 377.165 32.956 377.125 32.924 377.085C32.884 377.045 32.864 376.985 32.864 376.905L32.864 376.329C32.864 376.249 32.888 376.181 32.936 376.125C32.984 376.069 33.048 376.045 33.128 376.053C33.296 376.061 33.468 376.097 33.644 376.161C33.82 376.225 34 376.329 34.184 376.473C34.36 376.609 34.52 376.781 34.664 376.989C34.8 377.197 34.912 377.449 35 377.745C35.08 378.033 35.12 378.361 35.12 378.729ZM35.12 372.072C35.12 372.68 35.004 373.188 34.772 373.596C34.54 374.004 34.22 374.316 33.812 374.532C33.396 374.748 32.924 374.868 32.396 374.892C32.26 374.9 32.088 374.904 31.88 374.904C31.664 374.904 31.492 374.9 31.364 374.892C30.828 374.868 30.356 374.748 29.948 374.532C29.54 374.308 29.22 373.992 28.988 373.584C28.756 373.176 28.64 372.672 28.64 372.072C28.64 371.472 28.756 370.968 28.988 370.56C29.22 370.152 29.54 369.84 29.948 369.624C30.356 369.4 30.828 369.276 31.364 369.252C31.492 369.244 31.664 369.24 31.88 369.24C32.088 369.24 32.26 369.244 32.396 369.252C32.924 369.276 33.396 369.396 33.812 369.612C34.22 369.828 34.54 370.14 34.772 370.548C35.004 370.956 35.12 371.464 35.12 372.072ZM34.196 372.072C34.196 371.576 34.04 371.18 33.728 370.884C33.408 370.588 32.944 370.428 32.336 370.404C32.216 370.396 32.064 370.392 31.88 370.392C31.696 370.392 31.544 370.396 31.424 370.404C30.816 370.428 30.356 370.588 30.044 370.884C29.724 371.18 29.564 371.576 29.564 372.072C29.564 372.568 29.724 372.968 30.044 373.272C30.356 373.568 30.816 373.724 31.424 373.74C31.544 373.748 31.696 373.752 31.88 373.752C32.064 373.752 32.216 373.748 32.336 373.74C32.944 373.724 33.408 373.568 33.728 373.272C34.04 372.968 34.196 372.568 34.196 372.072ZM35 367.461C35 367.541 34.976 367.609 34.928 367.665C34.872 367.713 34.804 367.737 34.724 367.737L29.048 367.737C28.968 367.737 28.9 367.713 28.844 367.665C28.788 367.609 28.76 367.541 28.76 367.461L28.76 366.909C28.76 366.829 28.788 366.761 28.844 366.705C28.9 366.649 28.968 366.621 29.048 366.621L29.576 366.621C29.304 366.461 29.1 366.241 28.964 365.961C28.828 365.681 28.76 365.345 28.76 364.953L28.76 364.473C28.76 364.393 28.788 364.329 28.844 364.281C28.892 364.233 28.956 364.209 29.036 364.209L29.528 364.209C29.608 364.209 29.672 364.233 29.72 364.281C29.768 364.329 29.792 364.393 29.792 364.473L29.792 365.193C29.792 365.625 29.92 365.965 30.176 366.213C30.424 366.461 30.764 366.585 31.196 366.585L34.724 366.585C34.804 366.585 34.872 366.613 34.928 366.669C34.976 366.725 35 366.793 35 366.873L35 367.461ZM35.12 360.812C35.12 361.636 34.868 362.292 34.364 362.78C33.852 363.268 33.156 363.536 32.276 363.584C32.172 363.592 32.04 363.596 31.88 363.596C31.712 363.596 31.576 363.592 31.472 363.584C30.904 363.552 30.408 363.42 29.984 363.188C29.552 362.956 29.22 362.64 28.988 362.24C28.756 361.832 28.64 361.356 28.64 360.812C28.64 360.204 28.768 359.696 29.024 359.288C29.28 358.872 29.644 358.556 30.116 358.34C30.588 358.124 31.14 358.016 31.772 358.016L31.976 358.016C32.064 358.016 32.132 358.044 32.18 358.1C32.228 358.148 32.252 358.212 32.252 358.292L32.252 362.444C32.26 362.444 32.276 362.444 32.3 362.444C32.324 362.444 32.344 362.444 32.36 362.444C32.688 362.428 32.996 362.356 33.284 362.228C33.564 362.1 33.792 361.916 33.968 361.676C34.144 361.436 34.232 361.148 34.232 360.812C34.232 360.524 34.188 360.284 34.1 360.092C34.012 359.9 33.916 359.744 33.812 359.624C33.7 359.504 33.616 359.424 33.56 359.384C33.456 359.312 33.396 359.256 33.38 359.216C33.356 359.176 33.344 359.112 33.344 359.024L33.344 358.448C33.344 358.368 33.368 358.304 33.416 358.256C33.456 358.2 33.516 358.176 33.596 358.184C33.716 358.192 33.864 358.256 34.04 358.376C34.208 358.496 34.376 358.668 34.544 358.892C34.712 359.116 34.852 359.388 34.964 359.708C35.068 360.028 35.12 360.396 35.12 360.812ZM31.424 362.444L31.424 359.156L31.388 359.156C31.028 359.156 30.708 359.224 30.428 359.36C30.148 359.488 29.928 359.676 29.768 359.924C29.6 360.172 29.516 360.468 29.516 360.812C29.516 361.156 29.6 361.452 29.768 361.7C29.928 361.94 30.148 362.124 30.428 362.252C30.708 362.38 31.028 362.444 31.388 362.444L31.424 362.444Z'
          fill='#9EA1B1'
        />
        <path
          d='M58.16 410.006C58.16 410.742 58.048 411.366 57.824 411.878C57.5893 412.379 57.2693 412.79 56.864 413.11C56.4587 413.43 55.9947 413.665 55.472 413.814C54.9493 413.953 54.3947 414.033 53.808 414.054C53.52 414.065 53.216 414.075 52.896 414.086C52.576 414.086 52.256 414.086 51.936 414.086C51.6053 414.075 51.2907 414.065 50.992 414.054C50.4053 414.043 49.8507 413.963 49.328 413.814C48.7947 413.654 48.3307 413.419 47.936 413.11C47.5307 412.79 47.216 412.374 46.992 411.862C46.7573 411.35 46.64 410.731 46.64 410.006C46.64 409.27 46.7573 408.651 46.992 408.15C47.216 407.638 47.5307 407.222 47.936 406.902C48.3307 406.582 48.7947 406.347 49.328 406.198C49.8507 406.038 50.4053 405.953 50.992 405.942C51.2907 405.931 51.6053 405.926 51.936 405.926C52.256 405.915 52.576 405.915 52.896 405.926C53.216 405.926 53.52 405.931 53.808 405.942C54.3947 405.953 54.9493 406.038 55.472 406.198C55.9947 406.347 56.4587 406.582 56.864 406.902C57.2693 407.211 57.5893 407.622 57.824 408.134C58.048 408.635 58.16 409.259 58.16 410.006ZM56.8 410.006C56.8 409.174 56.528 408.561 55.984 408.166C55.4293 407.761 54.6773 407.553 53.728 407.542C53.4187 407.521 53.12 407.51 52.832 407.51C52.5333 407.51 52.24 407.51 51.952 407.51C51.6533 407.51 51.36 407.521 51.072 407.542C50.144 407.553 49.4027 407.761 48.848 408.166C48.2827 408.561 48 409.174 48 410.006C48 410.827 48.2827 411.441 48.848 411.846C49.4027 412.241 50.144 412.449 51.072 412.47C51.36 412.47 51.6533 412.475 51.952 412.486C52.24 412.486 52.5333 412.486 52.832 412.486C53.12 412.475 53.4187 412.47 53.728 412.47C54.6773 412.449 55.4293 412.235 55.984 411.83C56.528 411.425 56.8 410.817 56.8 410.006Z'
          fill='#FFA97F'
        />
        <path
          d='M413.221 35.5C413.104 35.5 413.013 35.468 412.949 35.404C412.885 35.3293 412.853 35.2387 412.853 35.132V24.684C412.853 24.5667 412.885 24.476 412.949 24.412C413.013 24.3373 413.104 24.3 413.221 24.3H414.037C414.154 24.3 414.245 24.3373 414.309 24.412C414.384 24.476 414.421 24.5667 414.421 24.684V29.1H419.925V24.684C419.925 24.5667 419.957 24.476 420.021 24.412C420.096 24.3373 420.186 24.3 420.293 24.3H421.109C421.226 24.3 421.317 24.3373 421.381 24.412C421.456 24.476 421.493 24.5667 421.493 24.684V35.132C421.493 35.2387 421.456 35.3293 421.381 35.404C421.317 35.468 421.226 35.5 421.109 35.5H420.293C420.186 35.5 420.096 35.468 420.021 35.404C419.957 35.3293 419.925 35.2387 419.925 35.132V30.54H414.421V35.132C414.421 35.2387 414.384 35.3293 414.309 35.404C414.245 35.468 414.154 35.5 414.037 35.5H413.221ZM424.627 35.5C424.51 35.5 424.419 35.468 424.355 35.404C424.291 35.3293 424.259 35.2387 424.259 35.132V24.668C424.259 24.5613 424.291 24.476 424.355 24.412C424.419 24.3373 424.51 24.3 424.627 24.3H425.475C425.582 24.3 425.667 24.3373 425.731 24.412C425.806 24.476 425.843 24.5613 425.843 24.668V35.132C425.843 35.2387 425.806 35.3293 425.731 35.404C425.667 35.468 425.582 35.5 425.475 35.5H424.627ZM432.698 35.66C431.76 35.66 430.96 35.484 430.298 35.132C429.648 34.78 429.146 34.284 428.794 33.644C428.453 33.004 428.261 32.252 428.218 31.388C428.208 30.9187 428.202 30.4227 428.202 29.9C428.202 29.3667 428.208 28.86 428.218 28.38C428.261 27.516 428.453 26.7693 428.794 26.14C429.146 25.5107 429.653 25.02 430.314 24.668C430.976 24.316 431.77 24.14 432.698 24.14C433.456 24.14 434.112 24.2467 434.666 24.46C435.221 24.6733 435.674 24.9453 436.026 25.276C436.389 25.596 436.656 25.932 436.826 26.284C437.008 26.636 437.104 26.9453 437.114 27.212C437.125 27.308 437.098 27.388 437.034 27.452C436.97 27.5053 436.885 27.532 436.778 27.532H435.834C435.728 27.532 435.648 27.5107 435.594 27.468C435.552 27.4253 435.509 27.3507 435.466 27.244C435.37 26.9667 435.21 26.6947 434.986 26.428C434.773 26.1613 434.48 25.9427 434.106 25.772C433.744 25.5907 433.274 25.5 432.698 25.5C431.856 25.5 431.173 25.7293 430.65 26.188C430.138 26.6467 429.861 27.404 429.818 28.46C429.786 29.4093 429.786 30.3587 429.818 31.308C429.861 32.3747 430.144 33.1427 430.666 33.612C431.189 34.0707 431.872 34.3 432.714 34.3C433.28 34.3 433.781 34.1987 434.218 33.996C434.666 33.7827 435.018 33.4573 435.274 33.02C435.53 32.5827 435.658 32.028 435.658 31.356V30.684H433.258C433.152 30.684 433.061 30.652 432.986 30.588C432.922 30.5133 432.89 30.4173 432.89 30.3V29.788C432.89 29.6707 432.922 29.58 432.986 29.516C433.061 29.4413 433.152 29.404 433.258 29.404H436.874C436.992 29.404 437.082 29.4413 437.146 29.516C437.21 29.58 437.242 29.6707 437.242 29.788V31.324C437.242 32.1987 437.061 32.9613 436.698 33.612C436.346 34.2627 435.829 34.7693 435.146 35.132C434.464 35.484 433.648 35.66 432.698 35.66ZM439.893 35.5C439.775 35.5 439.685 35.468 439.621 35.404C439.557 35.3293 439.525 35.2387 439.525 35.132V24.684C439.525 24.5667 439.557 24.476 439.621 24.412C439.685 24.3373 439.775 24.3 439.893 24.3H440.709C440.826 24.3 440.917 24.3373 440.981 24.412C441.055 24.476 441.093 24.5667 441.093 24.684V29.1H446.597V24.684C446.597 24.5667 446.629 24.476 446.693 24.412C446.767 24.3373 446.858 24.3 446.965 24.3H447.781C447.898 24.3 447.989 24.3373 448.053 24.412C448.127 24.476 448.165 24.5667 448.165 24.684V35.132C448.165 35.2387 448.127 35.3293 448.053 35.404C447.989 35.468 447.898 35.5 447.781 35.5H446.965C446.858 35.5 446.767 35.468 446.693 35.404C446.629 35.3293 446.597 35.2387 446.597 35.132V30.54H441.093V35.132C441.093 35.2387 441.055 35.3293 440.981 35.404C440.917 35.468 440.826 35.5 440.709 35.5H439.893Z'
          fill='#FFA7A0'
        />
        <path
          d='M71.3915 262.897C71.3382 262.99 71.2651 263.052 71.1724 263.085C71.0757 263.103 70.9812 263.085 70.8888 263.032L61.8406 257.808C61.7389 257.749 61.6764 257.676 61.653 257.589C61.6257 257.487 61.6387 257.39 61.692 257.297L62.092 256.604C62.156 256.493 62.2317 256.426 62.3191 256.403C62.4066 256.379 62.4714 256.374 62.5137 256.386L69.8077 256.68L65.9137 250.497C65.8874 250.457 65.8599 250.398 65.8311 250.32C65.8077 250.233 65.828 250.133 65.892 250.023L66.284 249.344C66.3427 249.242 66.4203 249.182 66.517 249.164C66.6098 249.131 66.7069 249.144 66.8086 249.203L75.8568 254.427C75.9492 254.48 76.009 254.558 76.0364 254.66C76.0598 254.747 76.0422 254.842 75.9835 254.944L75.5915 255.623C75.5382 255.715 75.4651 255.777 75.3724 255.81C75.2757 255.828 75.1812 255.811 75.0888 255.757L68.2714 251.821L71.4526 256.743C71.5237 256.834 71.5656 256.932 71.5783 257.038C71.5819 257.138 71.5516 257.244 71.4876 257.355L71.2396 257.784C71.1703 257.904 71.0912 257.988 71.0023 258.035C70.9096 258.068 70.8037 258.081 70.6846 258.073L64.8314 257.779L71.6488 261.715C71.7412 261.769 71.801 261.846 71.8284 261.948C71.8518 262.036 71.8368 262.126 71.7835 262.218L71.3915 262.897ZM79.7056 248.817C79.2523 249.602 78.729 250.199 78.1358 250.608C77.5333 251.011 76.8623 251.203 76.1229 251.182C75.3741 251.156 74.5595 250.914 73.6791 250.455C73.2673 250.229 72.8767 250.01 72.5072 249.797C72.1284 249.578 71.7385 249.347 71.3374 249.103C70.5088 248.575 69.9035 247.992 69.5213 247.352C69.1353 246.698 68.9664 246.01 69.0146 245.286C69.0589 244.548 69.297 243.805 69.729 243.057C70.1663 242.299 70.6909 241.721 71.3026 241.323C71.9104 240.91 72.5939 240.708 73.3533 240.715C74.1035 240.717 74.9115 240.95 75.7774 241.413C76.1945 241.629 76.5924 241.846 76.9712 242.065C77.3407 242.278 77.7233 242.511 78.1191 242.765C78.9622 243.288 79.5795 243.872 79.9709 244.517C80.3583 245.147 80.528 245.824 80.4798 246.548C80.4223 247.266 80.1643 248.022 79.7056 248.817ZM78.5278 248.137C78.9385 247.425 79.0594 246.725 78.8904 246.037C78.7268 245.339 78.18 244.696 77.2498 244.11C76.8448 243.852 76.4806 243.629 76.1573 243.442C75.8248 243.25 75.4499 243.046 75.0328 242.83C74.3847 242.481 73.7981 242.302 73.2729 242.294C72.753 242.278 72.2967 242.396 71.9039 242.65C71.5112 242.903 71.1788 243.266 70.9068 243.737C70.6455 244.189 70.5032 244.649 70.4799 245.116C70.4567 245.583 70.5797 246.042 70.8489 246.493C71.1234 246.935 71.5714 247.354 72.1928 247.749C72.5939 247.993 72.9608 248.211 73.2933 248.403C73.6166 248.59 73.9888 248.798 74.4098 249.029C75.3826 249.542 76.2122 249.694 76.8984 249.487C77.5847 249.28 78.1278 248.829 78.5278 248.137ZM83.1571 242.518C83.0985 242.62 83.0254 242.683 82.938 242.706C82.8413 242.724 82.7468 242.706 82.6544 242.653L73.6062 237.429C73.5046 237.37 73.4421 237.297 73.4186 237.21C73.386 237.117 73.399 237.02 73.4576 236.918L75.2736 233.773C75.823 232.822 76.4088 232.138 77.0312 231.721C77.6535 231.304 78.3238 231.125 79.042 231.182C79.7509 231.234 80.5145 231.49 81.3327 231.95C81.7537 232.181 82.1213 232.387 82.4354 232.569C82.7495 232.75 83.1071 232.963 83.5082 233.206C84.3474 233.716 84.9714 234.267 85.3802 234.86C85.7851 235.439 85.9608 236.094 85.9073 236.827C85.8498 237.545 85.5518 238.371 85.0131 239.304L83.1571 242.518ZM82.5793 240.799L83.7953 238.693C84.1633 238.056 84.3689 237.497 84.4121 237.017C84.4552 236.537 84.3308 236.102 84.0388 235.711C83.7522 235.312 83.2928 234.923 82.6608 234.546C82.3943 234.368 82.1594 234.22 81.9562 234.102C81.7438 233.98 81.5359 233.86 81.3327 233.742C81.1202 233.62 80.8747 233.49 80.5961 233.354C79.6894 232.855 78.9063 232.686 78.2467 232.848C77.5778 233.003 76.9661 233.562 76.4114 234.522L75.2354 236.559L82.5793 240.799ZM88.6727 232.965C88.6141 233.067 88.541 233.129 88.4536 233.153C88.3569 233.171 88.2624 233.153 88.17 233.1L79.1218 227.876C79.0202 227.817 78.9577 227.744 78.9343 227.657C78.9016 227.564 78.9146 227.467 78.9733 227.365L82.2773 221.642C82.3359 221.541 82.4136 221.481 82.5103 221.463C82.5977 221.439 82.6922 221.457 82.7938 221.516L83.3204 221.82C83.422 221.878 83.4845 221.951 83.5079 222.039C83.5313 222.126 83.5137 222.221 83.4551 222.322L80.7351 227.034L83.7696 228.786L86.3136 224.379C86.3723 224.278 86.4499 224.218 86.5466 224.2C86.634 224.176 86.7285 224.194 86.8302 224.253L87.3428 224.549C87.4352 224.602 87.4977 224.675 87.5304 224.768C87.5538 224.855 87.5362 224.95 87.4775 225.051L84.9335 229.458L88.0789 231.274L90.8629 226.452C90.9216 226.35 90.9947 226.287 91.0821 226.264C91.1695 226.241 91.264 226.258 91.3656 226.317L91.906 226.629C91.9984 226.682 92.0609 226.755 92.0936 226.848C92.117 226.935 92.0994 227.03 92.0407 227.132L88.6727 232.965ZM93.5243 224.562C93.4656 224.664 93.3926 224.726 93.3052 224.75C93.2085 224.768 93.114 224.75 93.0216 224.697L83.9734 219.473C83.8718 219.414 83.8092 219.341 83.7858 219.254C83.7532 219.161 83.7662 219.064 83.8248 218.962L85.7768 215.581C86.3795 214.537 87.1016 213.852 87.9432 213.525C88.7848 213.198 89.686 213.312 90.6467 213.866C91.358 214.277 91.8359 214.793 92.0806 215.415C92.3213 216.022 92.3534 216.681 92.177 217.392L97.0948 217.386C97.1662 217.39 97.225 217.406 97.2712 217.432C97.3451 217.475 97.3911 217.545 97.4092 217.641C97.4326 217.729 97.423 217.809 97.3803 217.883L96.9963 218.548C96.9056 218.705 96.7974 218.797 96.6716 218.823C96.5458 218.849 96.4253 218.865 96.3102 218.873L91.6307 218.85L90.2307 221.275L93.8056 223.339C93.898 223.392 93.9578 223.47 93.9852 223.572C94.0086 223.659 93.991 223.754 93.9323 223.855L93.5243 224.562ZM89.0529 220.595L90.3729 218.308C90.7729 217.616 90.9283 217.016 90.8393 216.509C90.741 215.996 90.4055 215.574 89.8328 215.244C89.2693 214.918 88.7411 214.841 88.2482 215.013C87.7606 215.174 87.3141 215.606 86.9088 216.308L85.5888 218.595L89.0529 220.595ZM98.2065 216.452C98.1638 216.526 98.0988 216.575 98.0114 216.598C97.9239 216.622 97.8433 216.612 97.7694 216.569C97.7232 216.543 97.675 216.509 97.6249 216.467L90.6438 207.855C90.5728 207.765 90.5282 207.671 90.5101 207.575C90.4921 207.478 90.5203 207.365 90.595 207.236L91.139 206.293C91.2083 206.173 91.2894 206.097 91.3821 206.064C91.4802 206.022 91.5861 206.01 91.6998 206.026L102.641 207.779C102.707 207.793 102.763 207.813 102.809 207.84C102.883 207.882 102.932 207.947 102.955 208.035C102.979 208.122 102.969 208.203 102.926 208.277L102.518 208.984C102.454 209.094 102.379 209.162 102.291 209.185C102.209 209.199 102.14 209.202 102.083 209.194L99.6753 208.82L97.0513 213.365L98.5789 215.263C98.6198 215.299 98.6519 215.361 98.6754 215.448C98.6988 215.536 98.6785 215.635 98.6145 215.746L98.2065 216.452ZM96.0917 212.275L98.2517 208.534L92.2526 207.565L96.0917 212.275ZM104.756 205.108C104.703 205.2 104.63 205.263 104.537 205.295C104.44 205.314 104.346 205.296 104.253 205.243L96.1059 200.539L94.5699 203.199C94.5165 203.291 94.4435 203.354 94.3507 203.387C94.2541 203.405 94.1595 203.387 94.0672 203.334L93.4852 202.998C93.3836 202.939 93.3211 202.866 93.2976 202.779C93.2703 202.677 93.2833 202.579 93.3366 202.487L97.1926 195.808C97.2513 195.707 97.329 195.647 97.4256 195.629C97.5184 195.596 97.6156 195.609 97.7172 195.668L98.2992 196.004C98.3915 196.057 98.4514 196.135 98.4787 196.237C98.5021 196.324 98.4845 196.419 98.4259 196.52L96.8979 199.167L105.045 203.871C105.138 203.924 105.198 204.002 105.225 204.104C105.248 204.191 105.231 204.286 105.172 204.387L104.756 205.108ZM108.165 199.204C108.106 199.305 108.033 199.368 107.946 199.391C107.849 199.409 107.755 199.392 107.662 199.338L98.614 194.114C98.5124 194.056 98.4499 193.983 98.4264 193.895C98.3938 193.802 98.4068 193.705 98.4654 193.604L101.769 187.881C101.828 187.779 101.906 187.72 102.002 187.701C102.09 187.678 102.184 187.696 102.286 187.754L102.813 188.058C102.914 188.117 102.977 188.19 103 188.277C103.024 188.365 103.006 188.459 102.947 188.561L100.227 193.272L103.262 195.024L105.806 190.618C105.864 190.516 105.942 190.456 106.039 190.438C106.126 190.415 106.221 190.432 106.322 190.491L106.835 190.787C106.927 190.84 106.99 190.913 107.023 191.006C107.046 191.094 107.028 191.188 106.97 191.29L104.426 195.696L107.571 197.512L110.355 192.69C110.414 192.589 110.487 192.526 110.574 192.503C110.662 192.479 110.756 192.497 110.858 192.555L111.398 192.867C111.491 192.921 111.553 192.994 111.586 193.087C111.609 193.174 111.592 193.269 111.533 193.37L108.165 199.204Z'
          fill='#FF6F26'
        />
        <path
          d='M69.1639 435.62C68.6599 435.62 68.2199 435.56 67.8439 435.44C67.4679 435.312 67.1519 435.144 66.8959 434.936C66.6399 434.728 66.4439 434.5 66.3079 434.252C66.1799 434.004 66.1119 433.748 66.1039 433.484C66.1039 433.412 66.1279 433.356 66.1759 433.316C66.2239 433.276 66.2839 433.256 66.3559 433.256H66.9439C67.0159 433.256 67.0799 433.272 67.1359 433.304C67.1919 433.336 67.2399 433.404 67.2799 433.508C67.3599 433.796 67.4959 434.02 67.6879 434.18C67.8879 434.34 68.1159 434.452 68.3719 434.516C68.6359 434.572 68.8999 434.6 69.1639 434.6C69.7159 434.6 70.1639 434.468 70.5079 434.204C70.8519 433.94 71.0239 433.552 71.0239 433.04C71.0239 432.52 70.8679 432.148 70.5559 431.924C70.2439 431.7 69.8119 431.588 69.2599 431.588H68.1199C68.0399 431.588 67.9719 431.564 67.9159 431.516C67.8679 431.468 67.8439 431.4 67.8439 431.312V430.988C67.8439 430.916 67.8559 430.856 67.8799 430.808C67.9119 430.752 67.9439 430.704 67.9759 430.664L70.3039 428.12H66.7639C66.6839 428.12 66.6159 428.096 66.5599 428.048C66.5119 428 66.4879 427.932 66.4879 427.844V427.388C66.4879 427.3 66.5119 427.232 66.5599 427.184C66.6159 427.128 66.6839 427.1 66.7639 427.1H71.5519C71.6399 427.1 71.7079 427.128 71.7559 427.184C71.8119 427.232 71.8399 427.3 71.8399 427.388V427.82C71.8399 427.876 71.8239 427.928 71.7919 427.976C71.7679 428.016 71.7399 428.056 71.7079 428.096L69.3919 430.676L69.5839 430.688C70.1119 430.704 70.5719 430.8 70.9639 430.976C71.3639 431.152 71.6719 431.416 71.8879 431.768C72.1119 432.112 72.2239 432.548 72.2239 433.076C72.2239 433.612 72.0919 434.072 71.8279 434.456C71.5639 434.832 71.1999 435.12 70.7359 435.32C70.2719 435.52 69.7479 435.62 69.1639 435.62ZM76.5989 435.62C76.0469 435.62 75.5789 435.536 75.1949 435.368C74.8189 435.192 74.5109 434.952 74.2709 434.648C74.0309 434.344 73.8549 433.996 73.7429 433.604C73.6389 433.212 73.5789 432.796 73.5629 432.356C73.5549 432.14 73.5469 431.912 73.5389 431.672C73.5389 431.432 73.5389 431.192 73.5389 430.952C73.5469 430.704 73.5549 430.468 73.5629 430.244C73.5709 429.804 73.6309 429.388 73.7429 428.996C73.8629 428.596 74.0389 428.248 74.2709 427.952C74.5109 427.648 74.8229 427.412 75.2069 427.244C75.5909 427.068 76.0549 426.98 76.5989 426.98C77.1509 426.98 77.6149 427.068 77.9909 427.244C78.3749 427.412 78.6869 427.648 78.9269 427.952C79.1669 428.248 79.3429 428.596 79.4549 428.996C79.5749 429.388 79.6389 429.804 79.6469 430.244C79.6549 430.468 79.6589 430.704 79.6589 430.952C79.6669 431.192 79.6669 431.432 79.6589 431.672C79.6589 431.912 79.6549 432.14 79.6469 432.356C79.6389 432.796 79.5749 433.212 79.4549 433.604C79.3429 433.996 79.1669 434.344 78.9269 434.648C78.6949 434.952 78.3869 435.192 78.0029 435.368C77.6269 435.536 77.1589 435.62 76.5989 435.62ZM76.5989 434.6C77.2229 434.6 77.6829 434.396 77.9789 433.988C78.2829 433.572 78.4389 433.008 78.4469 432.296C78.4629 432.064 78.4709 431.84 78.4709 431.624C78.4709 431.4 78.4709 431.18 78.4709 430.964C78.4709 430.74 78.4629 430.52 78.4469 430.304C78.4389 429.608 78.2829 429.052 77.9789 428.636C77.6829 428.212 77.2229 428 76.5989 428C75.9829 428 75.5229 428.212 75.2189 428.636C74.9229 429.052 74.7669 429.608 74.7509 430.304C74.7509 430.52 74.7469 430.74 74.7389 430.964C74.7389 431.18 74.7389 431.4 74.7389 431.624C74.7469 431.84 74.7509 432.064 74.7509 432.296C74.7669 433.008 74.9269 433.572 75.2309 433.988C75.5349 434.396 75.9909 434.6 76.5989 434.6Z'
          fill='#9EA1B1'
        />
        <path
          d='M187.183 435.5C187.103 435.5 187.035 435.476 186.979 435.428C186.931 435.372 186.907 435.304 186.907 435.224V428.504L184.915 430.04C184.851 430.088 184.783 430.108 184.711 430.1C184.639 430.092 184.579 430.056 184.531 429.992L184.219 429.596C184.171 429.524 184.151 429.452 184.159 429.38C184.175 429.308 184.215 429.248 184.279 429.2L186.895 427.184C186.951 427.144 187.003 427.12 187.051 427.112C187.099 427.104 187.151 427.1 187.207 427.1H187.819C187.899 427.1 187.963 427.128 188.011 427.184C188.059 427.232 188.083 427.296 188.083 427.376V435.224C188.083 435.304 188.059 435.372 188.011 435.428C187.963 435.476 187.899 435.5 187.819 435.5H187.183ZM192.508 435.62C191.876 435.62 191.34 435.512 190.9 435.296C190.468 435.072 190.136 434.784 189.904 434.432C189.68 434.08 189.56 433.708 189.544 433.316C189.536 433.244 189.556 433.188 189.604 433.148C189.652 433.108 189.712 433.088 189.784 433.088H190.432C190.504 433.088 190.568 433.104 190.624 433.136C190.68 433.168 190.724 433.236 190.756 433.34C190.836 433.636 190.964 433.88 191.14 434.072C191.324 434.256 191.532 434.392 191.764 434.48C192.004 434.56 192.252 434.6 192.508 434.6C192.852 434.6 193.164 434.532 193.444 434.396C193.732 434.252 193.96 434.044 194.128 433.772C194.296 433.492 194.38 433.156 194.38 432.764C194.38 432.404 194.296 432.096 194.128 431.84C193.968 431.576 193.744 431.376 193.456 431.24C193.176 431.096 192.86 431.024 192.508 431.024C192.244 431.024 192.028 431.056 191.86 431.12C191.692 431.184 191.548 431.26 191.428 431.348C191.316 431.436 191.212 431.512 191.116 431.576C191.028 431.64 190.928 431.672 190.816 431.672H190.192C190.12 431.672 190.056 431.648 190 431.6C189.944 431.544 189.92 431.48 189.928 431.408L190.312 427.4C190.32 427.304 190.348 427.232 190.396 427.184C190.452 427.128 190.524 427.1 190.612 427.1H194.8C194.88 427.1 194.944 427.128 194.992 427.184C195.048 427.232 195.076 427.296 195.076 427.376V427.844C195.076 427.932 195.048 428 194.992 428.048C194.944 428.096 194.88 428.12 194.8 428.12H191.344L191.116 430.484C191.228 430.412 191.408 430.328 191.656 430.232C191.904 430.128 192.244 430.076 192.676 430.076C193.068 430.076 193.436 430.136 193.78 430.256C194.132 430.376 194.444 430.552 194.716 430.784C194.988 431.016 195.2 431.3 195.352 431.636C195.504 431.964 195.58 432.344 195.58 432.776C195.58 433.384 195.444 433.9 195.172 434.324C194.908 434.748 194.544 435.072 194.08 435.296C193.624 435.512 193.1 435.62 192.508 435.62Z'
          fill='#9EA1B1'
        />
        <path
          d='M306.995 435.62C306.443 435.62 305.975 435.536 305.591 435.368C305.215 435.192 304.907 434.952 304.667 434.648C304.427 434.344 304.251 433.996 304.139 433.604C304.035 433.212 303.975 432.796 303.959 432.356C303.951 432.14 303.943 431.912 303.935 431.672C303.935 431.432 303.935 431.192 303.935 430.952C303.943 430.704 303.951 430.468 303.959 430.244C303.967 429.804 304.027 429.388 304.139 428.996C304.259 428.596 304.435 428.248 304.667 427.952C304.907 427.648 305.219 427.412 305.603 427.244C305.987 427.068 306.451 426.98 306.995 426.98C307.547 426.98 308.011 427.068 308.387 427.244C308.771 427.412 309.083 427.648 309.323 427.952C309.563 428.248 309.739 428.596 309.851 428.996C309.971 429.388 310.035 429.804 310.043 430.244C310.051 430.468 310.055 430.704 310.055 430.952C310.063 431.192 310.063 431.432 310.055 431.672C310.055 431.912 310.051 432.14 310.043 432.356C310.035 432.796 309.971 433.212 309.851 433.604C309.739 433.996 309.563 434.344 309.323 434.648C309.091 434.952 308.783 435.192 308.399 435.368C308.023 435.536 307.555 435.62 306.995 435.62ZM306.995 434.6C307.619 434.6 308.079 434.396 308.375 433.988C308.679 433.572 308.835 433.008 308.843 432.296C308.859 432.064 308.867 431.84 308.867 431.624C308.867 431.4 308.867 431.18 308.867 430.964C308.867 430.74 308.859 430.52 308.843 430.304C308.835 429.608 308.679 429.052 308.375 428.636C308.079 428.212 307.619 428 306.995 428C306.379 428 305.919 428.212 305.615 428.636C305.319 429.052 305.163 429.608 305.147 430.304C305.147 430.52 305.143 430.74 305.135 430.964C305.135 431.18 305.135 431.4 305.135 431.624C305.143 431.84 305.147 432.064 305.147 432.296C305.163 433.008 305.323 433.572 305.627 433.988C305.931 434.396 306.387 434.6 306.995 434.6Z'
          fill='#9EA1B1'
        />
        <path
          d='M140.923 455.5C140.803 455.5 140.707 455.472 140.635 455.416C140.571 455.36 140.519 455.284 140.479 455.188L137.803 447.472C137.787 447.424 137.779 447.38 137.779 447.34C137.779 447.276 137.803 447.22 137.851 447.172C137.899 447.124 137.955 447.1 138.019 447.1H138.643C138.739 447.1 138.811 447.128 138.859 447.184C138.915 447.232 138.947 447.276 138.955 447.316L141.307 454.12L143.659 447.316C143.675 447.276 143.707 447.232 143.755 447.184C143.803 447.128 143.875 447.1 143.971 447.1H144.595C144.659 447.1 144.715 447.124 144.763 447.172C144.819 447.22 144.847 447.276 144.847 447.34C144.847 447.38 144.839 447.424 144.823 447.472L142.135 455.188C142.103 455.284 142.051 455.36 141.979 455.416C141.915 455.472 141.823 455.5 141.703 455.5H140.923ZM146.363 455.5C146.283 455.5 146.215 455.476 146.159 455.428C146.111 455.372 146.087 455.304 146.087 455.224V449.536C146.087 449.456 146.111 449.392 146.159 449.344C146.215 449.288 146.283 449.26 146.363 449.26H146.939C147.019 449.26 147.083 449.288 147.131 449.344C147.179 449.392 147.203 449.456 147.203 449.536V455.224C147.203 455.304 147.179 455.372 147.131 455.428C147.083 455.476 147.019 455.5 146.939 455.5H146.363ZM146.267 448.096C146.187 448.096 146.119 448.072 146.063 448.024C146.015 447.968 145.991 447.9 145.991 447.82V447.172C145.991 447.092 146.015 447.028 146.063 446.98C146.119 446.924 146.187 446.896 146.267 446.896H147.023C147.103 446.896 147.167 446.924 147.215 446.98C147.271 447.028 147.299 447.092 147.299 447.172V447.82C147.299 447.9 147.271 447.968 147.215 448.024C147.167 448.072 147.103 448.096 147.023 448.096H146.267ZM151.549 455.62C150.941 455.62 150.433 455.504 150.025 455.272C149.617 455.04 149.305 454.72 149.089 454.312C148.873 453.896 148.753 453.424 148.729 452.896C148.721 452.76 148.717 452.588 148.717 452.38C148.717 452.164 148.721 451.992 148.729 451.864C148.753 451.328 148.873 450.856 149.089 450.448C149.313 450.04 149.629 449.72 150.037 449.488C150.445 449.256 150.949 449.14 151.549 449.14C152.149 449.14 152.653 449.256 153.061 449.488C153.469 449.72 153.781 450.04 153.997 450.448C154.221 450.856 154.345 451.328 154.369 451.864C154.377 451.992 154.381 452.164 154.381 452.38C154.381 452.588 154.377 452.76 154.369 452.896C154.345 453.424 154.225 453.896 154.009 454.312C153.793 454.72 153.481 455.04 153.073 455.272C152.665 455.504 152.157 455.62 151.549 455.62ZM151.549 454.696C152.045 454.696 152.441 454.54 152.737 454.228C153.033 453.908 153.193 453.444 153.217 452.836C153.225 452.716 153.229 452.564 153.229 452.38C153.229 452.196 153.225 452.044 153.217 451.924C153.193 451.316 153.033 450.856 152.737 450.544C152.441 450.224 152.045 450.064 151.549 450.064C151.053 450.064 150.653 450.224 150.349 450.544C150.053 450.856 149.897 451.316 149.881 451.924C149.873 452.044 149.869 452.196 149.869 452.38C149.869 452.564 149.873 452.716 149.881 452.836C149.897 453.444 150.053 453.908 150.349 454.228C150.653 454.54 151.053 454.696 151.549 454.696ZM156.172 455.5C156.092 455.5 156.024 455.476 155.968 455.428C155.92 455.372 155.896 455.304 155.896 455.224V447.256C155.896 447.176 155.92 447.112 155.968 447.064C156.024 447.008 156.092 446.98 156.172 446.98H156.736C156.824 446.98 156.892 447.008 156.94 447.064C156.988 447.112 157.012 447.176 157.012 447.256V455.224C157.012 455.304 156.988 455.372 156.94 455.428C156.892 455.476 156.824 455.5 156.736 455.5H156.172ZM160.542 455.62C160.142 455.62 159.778 455.54 159.45 455.38C159.122 455.22 158.858 455.004 158.658 454.732C158.458 454.46 158.358 454.152 158.358 453.808C158.358 453.256 158.582 452.816 159.03 452.488C159.478 452.16 160.062 451.944 160.782 451.84L162.57 451.588V451.24C162.57 450.856 162.458 450.556 162.234 450.34C162.018 450.124 161.662 450.016 161.166 450.016C160.806 450.016 160.514 450.088 160.29 450.232C160.074 450.376 159.922 450.56 159.834 450.784C159.786 450.904 159.702 450.964 159.582 450.964H159.042C158.954 450.964 158.886 450.94 158.838 450.892C158.798 450.836 158.778 450.772 158.778 450.7C158.778 450.58 158.822 450.432 158.91 450.256C159.006 450.08 159.15 449.908 159.342 449.74C159.534 449.572 159.778 449.432 160.074 449.32C160.378 449.2 160.746 449.14 161.178 449.14C161.658 449.14 162.062 449.204 162.39 449.332C162.718 449.452 162.974 449.616 163.158 449.824C163.35 450.032 163.486 450.268 163.566 450.532C163.654 450.796 163.698 451.064 163.698 451.336V455.224C163.698 455.304 163.67 455.372 163.614 455.428C163.566 455.476 163.502 455.5 163.422 455.5H162.87C162.782 455.5 162.714 455.476 162.666 455.428C162.618 455.372 162.594 455.304 162.594 455.224V454.708C162.49 454.852 162.35 454.996 162.174 455.14C161.998 455.276 161.778 455.392 161.514 455.488C161.25 455.576 160.926 455.62 160.542 455.62ZM160.794 454.72C161.122 454.72 161.422 454.652 161.694 454.516C161.966 454.372 162.178 454.152 162.33 453.856C162.49 453.56 162.57 453.188 162.57 452.74V452.404L161.178 452.608C160.61 452.688 160.182 452.824 159.894 453.016C159.606 453.2 159.462 453.436 159.462 453.724C159.462 453.948 159.526 454.136 159.654 454.288C159.79 454.432 159.958 454.54 160.158 454.612C160.366 454.684 160.578 454.72 160.794 454.72ZM167.801 455.5C167.353 455.5 166.989 455.416 166.709 455.248C166.429 455.072 166.225 454.828 166.097 454.516C165.969 454.196 165.905 453.82 165.905 453.388V450.22H164.969C164.889 450.22 164.821 450.196 164.765 450.148C164.717 450.092 164.693 450.024 164.693 449.944V449.536C164.693 449.456 164.717 449.392 164.765 449.344C164.821 449.288 164.889 449.26 164.969 449.26H165.905V447.256C165.905 447.176 165.929 447.112 165.977 447.064C166.033 447.008 166.101 446.98 166.181 446.98H166.745C166.825 446.98 166.889 447.008 166.937 447.064C166.993 447.112 167.021 447.176 167.021 447.256V449.26H168.509C168.589 449.26 168.653 449.288 168.701 449.344C168.757 449.392 168.785 449.456 168.785 449.536V449.944C168.785 450.024 168.757 450.092 168.701 450.148C168.653 450.196 168.589 450.22 168.509 450.22H167.021V453.304C167.021 453.68 167.085 453.976 167.213 454.192C167.341 454.408 167.569 454.516 167.897 454.516H168.629C168.709 454.516 168.773 454.544 168.821 454.6C168.877 454.648 168.905 454.712 168.905 454.792V455.224C168.905 455.304 168.877 455.372 168.821 455.428C168.773 455.476 168.709 455.5 168.629 455.5H167.801ZM170.328 455.5C170.248 455.5 170.18 455.476 170.124 455.428C170.076 455.372 170.052 455.304 170.052 455.224V449.536C170.052 449.456 170.076 449.392 170.124 449.344C170.18 449.288 170.248 449.26 170.328 449.26H170.904C170.984 449.26 171.048 449.288 171.096 449.344C171.144 449.392 171.168 449.456 171.168 449.536V455.224C171.168 455.304 171.144 455.372 171.096 455.428C171.048 455.476 170.984 455.5 170.904 455.5H170.328ZM170.232 448.096C170.152 448.096 170.084 448.072 170.028 448.024C169.98 447.968 169.956 447.9 169.956 447.82V447.172C169.956 447.092 169.98 447.028 170.028 446.98C170.084 446.924 170.152 446.896 170.232 446.896H170.988C171.068 446.896 171.132 446.924 171.18 446.98C171.236 447.028 171.264 447.092 171.264 447.172V447.82C171.264 447.9 171.236 447.968 171.18 448.024C171.132 448.072 171.068 448.096 170.988 448.096H170.232ZM175.514 455.62C174.906 455.62 174.398 455.504 173.99 455.272C173.582 455.04 173.27 454.72 173.054 454.312C172.838 453.896 172.718 453.424 172.694 452.896C172.686 452.76 172.682 452.588 172.682 452.38C172.682 452.164 172.686 451.992 172.694 451.864C172.718 451.328 172.838 450.856 173.054 450.448C173.278 450.04 173.594 449.72 174.002 449.488C174.41 449.256 174.914 449.14 175.514 449.14C176.114 449.14 176.618 449.256 177.026 449.488C177.434 449.72 177.746 450.04 177.962 450.448C178.186 450.856 178.31 451.328 178.334 451.864C178.342 451.992 178.346 452.164 178.346 452.38C178.346 452.588 178.342 452.76 178.334 452.896C178.31 453.424 178.19 453.896 177.974 454.312C177.758 454.72 177.446 455.04 177.038 455.272C176.63 455.504 176.122 455.62 175.514 455.62ZM175.514 454.696C176.01 454.696 176.406 454.54 176.702 454.228C176.998 453.908 177.158 453.444 177.182 452.836C177.19 452.716 177.194 452.564 177.194 452.38C177.194 452.196 177.19 452.044 177.182 451.924C177.158 451.316 176.998 450.856 176.702 450.544C176.406 450.224 176.01 450.064 175.514 450.064C175.018 450.064 174.618 450.224 174.314 450.544C174.018 450.856 173.862 451.316 173.846 451.924C173.838 452.044 173.834 452.196 173.834 452.38C173.834 452.564 173.838 452.716 173.846 452.836C173.862 453.444 174.018 453.908 174.314 454.228C174.618 454.54 175.018 454.696 175.514 454.696ZM180.125 455.5C180.045 455.5 179.977 455.476 179.921 455.428C179.873 455.372 179.849 455.304 179.849 455.224V449.536C179.849 449.456 179.873 449.392 179.921 449.344C179.977 449.288 180.045 449.26 180.125 449.26H180.689C180.769 449.26 180.833 449.288 180.881 449.344C180.937 449.392 180.965 449.456 180.965 449.536V450.064C181.173 449.792 181.433 449.572 181.745 449.404C182.065 449.228 182.473 449.14 182.969 449.14C183.489 449.14 183.929 449.256 184.289 449.488C184.657 449.712 184.933 450.028 185.117 450.436C185.301 450.836 185.393 451.304 185.393 451.84V455.224C185.393 455.304 185.369 455.372 185.321 455.428C185.273 455.476 185.209 455.5 185.129 455.5H184.529C184.449 455.5 184.381 455.476 184.325 455.428C184.277 455.372 184.253 455.304 184.253 455.224V451.9C184.253 451.34 184.117 450.904 183.845 450.592C183.573 450.272 183.173 450.112 182.645 450.112C182.149 450.112 181.749 450.272 181.445 450.592C181.149 450.904 181.001 451.34 181.001 451.9V455.224C181.001 455.304 180.973 455.372 180.917 455.428C180.869 455.476 180.805 455.5 180.725 455.5H180.125ZM189.343 455.5C189.279 455.5 189.223 455.476 189.175 455.428C189.127 455.38 189.103 455.324 189.103 455.26C189.103 455.22 189.107 455.176 189.115 455.128L192.091 447.364C192.123 447.284 192.167 447.22 192.223 447.172C192.279 447.124 192.363 447.1 192.475 447.1H193.291C193.395 447.1 193.475 447.124 193.531 447.172C193.595 447.22 193.643 447.284 193.675 447.364L196.639 455.128C196.655 455.176 196.663 455.22 196.663 455.26C196.663 455.324 196.639 455.38 196.591 455.428C196.543 455.476 196.487 455.5 196.423 455.5H195.811C195.715 455.5 195.643 455.476 195.595 455.428C195.555 455.38 195.527 455.336 195.511 455.296L194.851 453.592H190.915L190.255 455.296C190.247 455.336 190.219 455.38 190.171 455.428C190.123 455.476 190.051 455.5 189.955 455.5H189.343ZM191.263 452.56H194.503L192.883 448.3L191.263 452.56ZM200.276 458.14C199.732 458.14 199.284 458.068 198.932 457.924C198.588 457.78 198.316 457.604 198.116 457.396C197.924 457.196 197.784 456.992 197.696 456.784C197.616 456.584 197.572 456.424 197.564 456.304C197.556 456.224 197.58 456.156 197.636 456.1C197.7 456.044 197.768 456.016 197.84 456.016H198.416C198.488 456.016 198.548 456.032 198.596 456.064C198.644 456.096 198.684 456.164 198.716 456.268C198.764 456.388 198.836 456.52 198.932 456.664C199.028 456.816 199.176 456.944 199.376 457.048C199.576 457.16 199.856 457.216 200.216 457.216C200.592 457.216 200.908 457.164 201.164 457.06C201.42 456.964 201.612 456.788 201.74 456.532C201.876 456.284 201.944 455.94 201.944 455.5V454.684C201.752 454.932 201.5 455.14 201.188 455.308C200.876 455.468 200.484 455.548 200.012 455.548C199.564 455.548 199.18 455.472 198.86 455.32C198.54 455.16 198.276 454.948 198.068 454.684C197.868 454.412 197.716 454.104 197.612 453.76C197.516 453.416 197.46 453.056 197.444 452.68C197.436 452.456 197.436 452.236 197.444 452.02C197.46 451.644 197.516 451.284 197.612 450.94C197.716 450.596 197.868 450.288 198.068 450.016C198.276 449.744 198.54 449.532 198.86 449.38C199.18 449.22 199.564 449.14 200.012 449.14C200.492 449.14 200.888 449.232 201.2 449.416C201.52 449.592 201.78 449.808 201.98 450.064V449.548C201.98 449.468 202.004 449.4 202.052 449.344C202.108 449.288 202.176 449.26 202.256 449.26H202.808C202.888 449.26 202.956 449.288 203.012 449.344C203.068 449.4 203.096 449.468 203.096 449.548V455.368C203.096 455.904 203.004 456.38 202.82 456.796C202.644 457.212 202.348 457.54 201.932 457.78C201.524 458.02 200.972 458.14 200.276 458.14ZM200.252 454.588C200.652 454.588 200.972 454.496 201.212 454.312C201.46 454.128 201.64 453.896 201.752 453.616C201.872 453.336 201.936 453.052 201.944 452.764C201.952 452.652 201.956 452.516 201.956 452.356C201.956 452.188 201.952 452.048 201.944 451.936C201.936 451.648 201.872 451.364 201.752 451.084C201.64 450.804 201.46 450.572 201.212 450.388C200.972 450.204 200.652 450.112 200.252 450.112C199.852 450.112 199.532 450.204 199.292 450.388C199.052 450.564 198.88 450.8 198.776 451.096C198.672 451.384 198.612 451.696 198.596 452.032C198.588 452.24 198.588 452.452 198.596 452.668C198.612 453.004 198.672 453.32 198.776 453.616C198.88 453.904 199.052 454.14 199.292 454.324C199.532 454.5 199.852 454.588 200.252 454.588ZM207.364 455.62C206.54 455.62 205.884 455.368 205.396 454.864C204.908 454.352 204.64 453.656 204.592 452.776C204.584 452.672 204.58 452.54 204.58 452.38C204.58 452.212 204.584 452.076 204.592 451.972C204.624 451.404 204.756 450.908 204.988 450.484C205.22 450.052 205.536 449.72 205.936 449.488C206.344 449.256 206.82 449.14 207.364 449.14C207.972 449.14 208.48 449.268 208.888 449.524C209.304 449.78 209.62 450.144 209.836 450.616C210.052 451.088 210.16 451.64 210.16 452.272V452.476C210.16 452.564 210.132 452.632 210.076 452.68C210.028 452.728 209.964 452.752 209.884 452.752H205.732C205.732 452.76 205.732 452.776 205.732 452.8C205.732 452.824 205.732 452.844 205.732 452.86C205.748 453.188 205.82 453.496 205.948 453.784C206.076 454.064 206.26 454.292 206.5 454.468C206.74 454.644 207.028 454.732 207.364 454.732C207.652 454.732 207.892 454.688 208.084 454.6C208.276 454.512 208.432 454.416 208.552 454.312C208.672 454.2 208.752 454.116 208.792 454.06C208.864 453.956 208.92 453.896 208.96 453.88C209 453.856 209.064 453.844 209.152 453.844H209.728C209.808 453.844 209.872 453.868 209.92 453.916C209.976 453.956 210 454.016 209.992 454.096C209.984 454.216 209.92 454.364 209.8 454.54C209.68 454.708 209.508 454.876 209.284 455.044C209.06 455.212 208.788 455.352 208.468 455.464C208.148 455.568 207.78 455.62 207.364 455.62ZM205.732 451.924H209.02V451.888C209.02 451.528 208.952 451.208 208.816 450.928C208.688 450.648 208.5 450.428 208.252 450.268C208.004 450.1 207.708 450.016 207.364 450.016C207.02 450.016 206.724 450.1 206.476 450.268C206.236 450.428 206.052 450.648 205.924 450.928C205.796 451.208 205.732 451.528 205.732 451.888V451.924ZM217.14 457.408C216.62 457.408 216.18 457.296 215.82 457.072C215.46 456.856 215.172 456.52 214.956 456.064C214.74 455.608 214.58 455.028 214.476 454.324C214.38 453.612 214.332 452.768 214.332 451.792C214.332 450.816 214.38 449.976 214.476 449.272C214.58 448.56 214.74 447.976 214.956 447.52C215.172 447.064 215.46 446.728 215.82 446.512C216.18 446.296 216.62 446.188 217.14 446.188C217.212 446.188 217.276 446.216 217.332 446.272C217.388 446.328 217.416 446.392 217.416 446.464V446.884C217.416 446.956 217.388 447.02 217.332 447.076C217.284 447.132 217.232 447.16 217.176 447.16C216.84 447.168 216.556 447.256 216.324 447.424C216.1 447.584 215.916 447.844 215.772 448.204C215.636 448.564 215.536 449.04 215.472 449.632C215.416 450.216 215.388 450.936 215.388 451.792C215.388 452.648 215.416 453.372 215.472 453.964C215.536 454.548 215.636 455.024 215.772 455.392C215.916 455.752 216.1 456.012 216.324 456.172C216.556 456.34 216.84 456.428 217.176 456.436C217.232 456.436 217.284 456.464 217.332 456.52C217.388 456.576 217.416 456.64 217.416 456.712V457.132C217.416 457.204 217.388 457.268 217.332 457.324C217.276 457.38 217.212 457.408 217.14 457.408ZM219.035 455.5C218.947 455.5 218.879 455.476 218.831 455.428C218.783 455.372 218.759 455.304 218.759 455.224V447.388C218.759 447.3 218.783 447.232 218.831 447.184C218.879 447.128 218.947 447.1 219.035 447.1H221.759C222.583 447.1 223.247 447.224 223.751 447.472C224.255 447.72 224.623 448.088 224.855 448.576C225.087 449.056 225.207 449.648 225.215 450.352C225.223 450.712 225.227 451.028 225.227 451.3C225.227 451.572 225.223 451.884 225.215 452.236C225.199 452.972 225.075 453.584 224.843 454.072C224.619 454.552 224.259 454.912 223.763 455.152C223.275 455.384 222.627 455.5 221.819 455.5H219.035ZM219.935 454.48H221.759C222.311 454.48 222.751 454.404 223.079 454.252C223.407 454.1 223.643 453.856 223.787 453.52C223.939 453.184 224.019 452.74 224.027 452.188C224.043 451.948 224.051 451.74 224.051 451.564C224.051 451.38 224.051 451.2 224.051 451.024C224.051 450.84 224.043 450.632 224.027 450.4C224.011 449.624 223.827 449.052 223.475 448.684C223.123 448.308 222.531 448.12 221.699 448.12H219.935V454.48ZM228.616 455.62C228.216 455.62 227.852 455.54 227.524 455.38C227.196 455.22 226.932 455.004 226.732 454.732C226.532 454.46 226.432 454.152 226.432 453.808C226.432 453.256 226.656 452.816 227.104 452.488C227.552 452.16 228.136 451.944 228.856 451.84L230.644 451.588V451.24C230.644 450.856 230.532 450.556 230.308 450.34C230.092 450.124 229.736 450.016 229.24 450.016C228.88 450.016 228.588 450.088 228.364 450.232C228.148 450.376 227.996 450.56 227.908 450.784C227.86 450.904 227.776 450.964 227.656 450.964H227.116C227.028 450.964 226.96 450.94 226.912 450.892C226.872 450.836 226.852 450.772 226.852 450.7C226.852 450.58 226.896 450.432 226.984 450.256C227.08 450.08 227.224 449.908 227.416 449.74C227.608 449.572 227.852 449.432 228.148 449.32C228.452 449.2 228.82 449.14 229.252 449.14C229.732 449.14 230.136 449.204 230.464 449.332C230.792 449.452 231.048 449.616 231.232 449.824C231.424 450.032 231.56 450.268 231.64 450.532C231.728 450.796 231.772 451.064 231.772 451.336V455.224C231.772 455.304 231.744 455.372 231.688 455.428C231.64 455.476 231.576 455.5 231.496 455.5H230.944C230.856 455.5 230.788 455.476 230.74 455.428C230.692 455.372 230.668 455.304 230.668 455.224V454.708C230.564 454.852 230.424 454.996 230.248 455.14C230.072 455.276 229.852 455.392 229.588 455.488C229.324 455.576 229 455.62 228.616 455.62ZM228.868 454.72C229.196 454.72 229.496 454.652 229.768 454.516C230.04 454.372 230.252 454.152 230.404 453.856C230.564 453.56 230.644 453.188 230.644 452.74V452.404L229.252 452.608C228.684 452.688 228.256 452.824 227.968 453.016C227.68 453.2 227.536 453.436 227.536 453.724C227.536 453.948 227.6 454.136 227.728 454.288C227.864 454.432 228.032 454.54 228.232 454.612C228.44 454.684 228.652 454.72 228.868 454.72ZM234.46 457.78C234.396 457.78 234.34 457.756 234.292 457.708C234.244 457.66 234.22 457.604 234.22 457.54C234.22 457.508 234.224 457.476 234.232 457.444C234.24 457.412 234.256 457.372 234.28 457.324L235.204 455.128L232.912 449.716C232.872 449.62 232.852 449.552 232.852 449.512C232.852 449.44 232.876 449.38 232.924 449.332C232.972 449.284 233.032 449.26 233.104 449.26H233.692C233.772 449.26 233.836 449.28 233.884 449.32C233.932 449.36 233.964 449.408 233.98 449.464L235.804 453.832L237.676 449.464C237.7 449.408 237.732 449.36 237.772 449.32C237.82 449.28 237.888 449.26 237.976 449.26H238.54C238.612 449.26 238.672 449.284 238.72 449.332C238.768 449.38 238.792 449.436 238.792 449.5C238.792 449.54 238.772 449.612 238.732 449.716L235.324 457.576C235.3 457.632 235.264 457.68 235.216 457.72C235.176 457.76 235.112 457.78 235.024 457.78H234.46ZM239.127 457.408C239.055 457.408 238.991 457.38 238.935 457.324C238.879 457.268 238.851 457.204 238.851 457.132V456.712C238.851 456.64 238.875 456.576 238.923 456.52C238.979 456.464 239.039 456.436 239.103 456.436C239.439 456.428 239.719 456.34 239.943 456.172C240.175 456.012 240.359 455.752 240.495 455.392C240.631 455.024 240.731 454.548 240.795 453.964C240.859 453.372 240.891 452.648 240.891 451.792C240.891 450.936 240.859 450.216 240.795 449.632C240.731 449.04 240.631 448.564 240.495 448.204C240.359 447.844 240.175 447.584 239.943 447.424C239.719 447.256 239.439 447.168 239.103 447.16C239.039 447.16 238.979 447.132 238.923 447.076C238.875 447.02 238.851 446.956 238.851 446.884V446.464C238.851 446.392 238.879 446.328 238.935 446.272C238.991 446.216 239.055 446.188 239.127 446.188C239.647 446.188 240.087 446.296 240.447 446.512C240.807 446.728 241.095 447.064 241.311 447.52C241.527 447.976 241.683 448.56 241.779 449.272C241.883 449.976 241.935 450.816 241.935 451.792C241.935 452.768 241.883 453.612 241.779 454.324C241.683 455.028 241.527 455.608 241.311 456.064C241.095 456.52 240.807 456.856 240.447 457.072C240.087 457.296 239.647 457.408 239.127 457.408Z'
          fill='#9EA1B1'
        />
        <path
          d='M554.995 435.62C554.443 435.62 553.975 435.536 553.591 435.368C553.215 435.192 552.907 434.952 552.667 434.648C552.427 434.344 552.251 433.996 552.139 433.604C552.035 433.212 551.975 432.796 551.959 432.356C551.951 432.14 551.943 431.912 551.935 431.672C551.935 431.432 551.935 431.192 551.935 430.952C551.943 430.704 551.951 430.468 551.959 430.244C551.967 429.804 552.027 429.388 552.139 428.996C552.259 428.596 552.435 428.248 552.667 427.952C552.907 427.648 553.219 427.412 553.603 427.244C553.987 427.068 554.451 426.98 554.995 426.98C555.547 426.98 556.011 427.068 556.387 427.244C556.771 427.412 557.083 427.648 557.323 427.952C557.563 428.248 557.739 428.596 557.851 428.996C557.971 429.388 558.035 429.804 558.043 430.244C558.051 430.468 558.055 430.704 558.055 430.952C558.063 431.192 558.063 431.432 558.055 431.672C558.055 431.912 558.051 432.14 558.043 432.356C558.035 432.796 557.971 433.212 557.851 433.604C557.739 433.996 557.563 434.344 557.323 434.648C557.091 434.952 556.783 435.192 556.399 435.368C556.023 435.536 555.555 435.62 554.995 435.62ZM554.995 434.6C555.619 434.6 556.079 434.396 556.375 433.988C556.679 433.572 556.835 433.008 556.843 432.296C556.859 432.064 556.867 431.84 556.867 431.624C556.867 431.4 556.867 431.18 556.867 430.964C556.867 430.74 556.859 430.52 556.843 430.304C556.835 429.608 556.679 429.052 556.375 428.636C556.079 428.212 555.619 428 554.995 428C554.379 428 553.919 428.212 553.615 428.636C553.319 429.052 553.163 429.608 553.147 430.304C553.147 430.52 553.143 430.74 553.135 430.964C553.135 431.18 553.135 431.4 553.135 431.624C553.143 431.84 553.147 432.064 553.147 432.296C553.163 433.008 553.323 433.572 553.627 433.988C553.931 434.396 554.387 434.6 554.995 434.6Z'
          fill='#9EA1B1'
        />
        <path
          d='M669.183 435.5C669.103 435.5 669.035 435.476 668.979 435.428C668.931 435.372 668.907 435.304 668.907 435.224V428.504L666.915 430.04C666.851 430.088 666.783 430.108 666.711 430.1C666.639 430.092 666.579 430.056 666.531 429.992L666.219 429.596C666.171 429.524 666.151 429.452 666.159 429.38C666.175 429.308 666.215 429.248 666.279 429.2L668.895 427.184C668.951 427.144 669.003 427.12 669.051 427.112C669.099 427.104 669.151 427.1 669.207 427.1H669.819C669.899 427.1 669.963 427.128 670.011 427.184C670.059 427.232 670.083 427.296 670.083 427.376V435.224C670.083 435.304 670.059 435.372 670.011 435.428C669.963 435.476 669.899 435.5 669.819 435.5H669.183ZM674.508 435.62C673.876 435.62 673.34 435.512 672.9 435.296C672.468 435.072 672.136 434.784 671.904 434.432C671.68 434.08 671.56 433.708 671.544 433.316C671.536 433.244 671.556 433.188 671.604 433.148C671.652 433.108 671.712 433.088 671.784 433.088H672.432C672.504 433.088 672.568 433.104 672.624 433.136C672.68 433.168 672.724 433.236 672.756 433.34C672.836 433.636 672.964 433.88 673.14 434.072C673.324 434.256 673.532 434.392 673.764 434.48C674.004 434.56 674.252 434.6 674.508 434.6C674.852 434.6 675.164 434.532 675.444 434.396C675.732 434.252 675.96 434.044 676.128 433.772C676.296 433.492 676.38 433.156 676.38 432.764C676.38 432.404 676.296 432.096 676.128 431.84C675.968 431.576 675.744 431.376 675.456 431.24C675.176 431.096 674.86 431.024 674.508 431.024C674.244 431.024 674.028 431.056 673.86 431.12C673.692 431.184 673.548 431.26 673.428 431.348C673.316 431.436 673.212 431.512 673.116 431.576C673.028 431.64 672.928 431.672 672.816 431.672H672.192C672.12 431.672 672.056 431.648 672 431.6C671.944 431.544 671.92 431.48 671.928 431.408L672.312 427.4C672.32 427.304 672.348 427.232 672.396 427.184C672.452 427.128 672.524 427.1 672.612 427.1H676.8C676.88 427.1 676.944 427.128 676.992 427.184C677.048 427.232 677.076 427.296 677.076 427.376V427.844C677.076 427.932 677.048 428 676.992 428.048C676.944 428.096 676.88 428.12 676.8 428.12H673.344L673.116 430.484C673.228 430.412 673.408 430.328 673.656 430.232C673.904 430.128 674.244 430.076 674.676 430.076C675.068 430.076 675.436 430.136 675.78 430.256C676.132 430.376 676.444 430.552 676.716 430.784C676.988 431.016 677.2 431.3 677.352 431.636C677.504 431.964 677.58 432.344 677.58 432.776C677.58 433.384 677.444 433.9 677.172 434.324C676.908 434.748 676.544 435.072 676.08 435.296C675.624 435.512 675.1 435.62 674.508 435.62Z'
          fill='#9EA1B1'
        />
        <path
          d='M401.181 381.5C400.967 381.5 400.797 381.436 400.669 381.308C400.541 381.18 400.477 381.009 400.477 380.796V380.316C400.477 380.103 400.53 379.9 400.637 379.708C400.765 379.495 400.978 379.249 401.277 378.972L409.565 370.684C410.375 369.937 410.994 369.287 411.421 368.732C411.847 368.177 412.135 367.633 412.285 367.1C412.455 366.545 412.541 365.937 412.541 365.276C412.541 363.847 412.125 362.727 411.293 361.916C410.482 361.105 409.319 360.7 407.805 360.7C406.845 360.7 406.013 360.892 405.309 361.276C404.605 361.66 404.05 362.204 403.645 362.908C403.239 363.591 402.973 364.391 402.845 365.308C402.823 365.564 402.727 365.756 402.557 365.884C402.386 365.991 402.237 366.044 402.109 366.044H401.469C401.255 366.044 401.085 365.991 400.957 365.884C400.85 365.756 400.797 365.607 400.797 365.436C400.818 364.711 400.967 363.964 401.245 363.196C401.522 362.407 401.938 361.681 402.493 361.02C403.069 360.359 403.794 359.825 404.669 359.42C405.543 358.993 406.589 358.78 407.805 358.78C409.426 358.78 410.727 359.089 411.709 359.708C412.711 360.327 413.437 361.127 413.885 362.108C414.333 363.089 414.557 364.145 414.557 365.276C414.557 366.151 414.429 366.961 414.173 367.708C413.917 368.433 413.533 369.148 413.021 369.852C412.509 370.535 411.858 371.239 411.069 371.964L403.581 379.58H414.301C414.535 379.58 414.717 379.644 414.845 379.772C414.973 379.9 415.037 380.081 415.037 380.316V380.796C415.037 381.009 414.973 381.18 414.845 381.308C414.717 381.436 414.535 381.5 414.301 381.5H401.181ZM419.759 381.5C419.545 381.5 419.375 381.436 419.247 381.308C419.119 381.18 419.055 381.009 419.055 380.796V379.26C419.055 379.047 419.119 378.876 419.247 378.748C419.375 378.599 419.545 378.524 419.759 378.524H421.295C421.508 378.524 421.679 378.599 421.807 378.748C421.956 378.876 422.031 379.047 422.031 379.26V380.796C422.031 381.009 421.956 381.18 421.807 381.308C421.679 381.436 421.508 381.5 421.295 381.5H419.759ZM436.742 381.5C436.529 381.5 436.358 381.436 436.23 381.308C436.102 381.18 436.038 381.009 436.038 380.796V375.74H425.478C425.265 375.74 425.094 375.676 424.966 375.548C424.838 375.42 424.774 375.249 424.774 375.036V374.524C424.774 374.481 424.795 374.364 424.838 374.172C424.881 373.98 424.977 373.777 425.126 373.564L434.854 359.644C435.11 359.281 435.505 359.1 436.038 359.1H437.35C437.563 359.1 437.734 359.164 437.862 359.292C437.99 359.42 438.054 359.591 438.054 359.804V373.82H440.966C441.179 373.82 441.35 373.884 441.478 374.012C441.606 374.14 441.67 374.311 441.67 374.524V375.036C441.67 375.249 441.606 375.42 441.478 375.548C441.35 375.676 441.179 375.74 440.966 375.74H438.054V380.796C438.054 381.009 437.99 381.18 437.862 381.308C437.734 381.436 437.563 381.5 437.35 381.5H436.742ZM427.302 373.82H436.038V361.372L427.302 373.82ZM446.493 381.5C446.28 381.5 446.109 381.436 445.981 381.308C445.853 381.18 445.789 381.009 445.789 380.796V359.836C445.789 359.601 445.853 359.42 445.981 359.292C446.109 359.164 446.28 359.1 446.493 359.1H447.069C447.304 359.1 447.485 359.164 447.613 359.292C447.741 359.42 447.805 359.601 447.805 359.836V368.156L457.501 359.58C457.587 359.516 457.725 359.42 457.917 359.292C458.109 359.164 458.376 359.1 458.717 359.1H459.229C459.4 359.1 459.549 359.164 459.677 359.292C459.805 359.42 459.869 359.569 459.869 359.74C459.869 359.911 459.816 360.049 459.709 360.156L448.861 369.82L460.381 380.412C460.509 380.54 460.573 380.689 460.573 380.86C460.573 381.031 460.509 381.18 460.381 381.308C460.253 381.436 460.104 381.5 459.933 381.5H459.389C459.048 381.5 458.781 381.436 458.589 381.308C458.397 381.18 458.259 381.084 458.173 381.02L447.805 371.548V380.796C447.805 381.009 447.741 381.18 447.613 381.308C447.485 381.436 447.304 381.5 447.069 381.5H446.493Z'
          fill='white'
        />
        <path
          d='M399.884 406.5C399.764 406.5 399.668 406.472 399.596 406.416C399.532 406.36 399.48 406.284 399.44 406.188L396.764 398.472C396.748 398.424 396.74 398.38 396.74 398.34C396.74 398.276 396.764 398.22 396.812 398.172C396.86 398.124 396.916 398.1 396.98 398.1H397.604C397.7 398.1 397.772 398.128 397.82 398.184C397.876 398.232 397.908 398.276 397.916 398.316L400.268 405.12L402.62 398.316C402.636 398.276 402.668 398.232 402.716 398.184C402.764 398.128 402.836 398.1 402.932 398.1H403.556C403.62 398.1 403.676 398.124 403.724 398.172C403.78 398.22 403.808 398.276 403.808 398.34C403.808 398.38 403.8 398.424 403.784 398.472L401.096 406.188C401.064 406.284 401.012 406.36 400.94 406.416C400.876 406.472 400.784 406.5 400.664 406.5H399.884ZM405.515 406.5C405.427 406.5 405.359 406.476 405.311 406.428C405.263 406.372 405.239 406.304 405.239 406.224V398.376C405.239 398.296 405.263 398.232 405.311 398.184C405.359 398.128 405.427 398.1 405.515 398.1H406.151C406.231 398.1 406.295 398.128 406.343 398.184C406.399 398.232 406.427 398.296 406.427 398.376V406.224C406.427 406.304 406.399 406.372 406.343 406.428C406.295 406.476 406.231 406.5 406.151 406.5H405.515ZM411.533 406.62C410.853 406.62 410.269 406.504 409.781 406.272C409.293 406.032 408.917 405.668 408.653 405.18C408.389 404.684 408.241 404.064 408.209 403.32C408.201 402.968 408.197 402.632 408.197 402.312C408.197 401.984 408.201 401.644 408.209 401.292C408.241 400.556 408.393 399.944 408.665 399.456C408.945 398.96 409.329 398.592 409.817 398.352C410.313 398.104 410.885 397.98 411.533 397.98C412.189 397.98 412.761 398.104 413.249 398.352C413.745 398.592 414.133 398.96 414.413 399.456C414.693 399.944 414.845 400.556 414.869 401.292C414.885 401.644 414.893 401.984 414.893 402.312C414.893 402.632 414.885 402.968 414.869 403.32C414.845 404.064 414.697 404.684 414.425 405.18C414.161 405.668 413.785 406.032 413.297 406.272C412.809 406.504 412.221 406.62 411.533 406.62ZM411.533 405.6C412.149 405.6 412.649 405.416 413.033 405.048C413.425 404.68 413.637 404.084 413.669 403.26C413.685 402.9 413.693 402.58 413.693 402.3C413.693 402.012 413.685 401.692 413.669 401.34C413.653 400.788 413.549 400.34 413.357 399.996C413.173 399.652 412.925 399.4 412.613 399.24C412.301 399.08 411.941 399 411.533 399C411.141 399 410.789 399.08 410.477 399.24C410.165 399.4 409.913 399.652 409.721 399.996C409.537 400.34 409.433 400.788 409.409 401.34C409.401 401.692 409.397 402.012 409.397 402.3C409.397 402.58 409.401 402.9 409.409 403.26C409.441 404.084 409.653 404.68 410.045 405.048C410.437 405.416 410.933 405.6 411.533 405.6ZM416.918 406.5C416.83 406.5 416.762 406.476 416.714 406.428C416.666 406.372 416.642 406.304 416.642 406.224V398.376C416.642 398.296 416.666 398.232 416.714 398.184C416.762 398.128 416.83 398.1 416.918 398.1H417.554C417.634 398.1 417.698 398.128 417.746 398.184C417.794 398.232 417.818 398.296 417.818 398.376V405.456H421.814C421.902 405.456 421.97 405.484 422.018 405.54C422.066 405.588 422.09 405.656 422.09 405.744V406.224C422.09 406.304 422.066 406.372 422.018 406.428C421.97 406.476 421.902 406.5 421.814 406.5H416.918ZM422.839 406.5C422.775 406.5 422.719 406.476 422.671 406.428C422.623 406.38 422.599 406.324 422.599 406.26C422.599 406.22 422.603 406.176 422.611 406.128L425.587 398.364C425.619 398.284 425.663 398.22 425.719 398.172C425.775 398.124 425.859 398.1 425.971 398.1H426.787C426.891 398.1 426.971 398.124 427.027 398.172C427.091 398.22 427.139 398.284 427.171 398.364L430.135 406.128C430.151 406.176 430.159 406.22 430.159 406.26C430.159 406.324 430.135 406.38 430.087 406.428C430.039 406.476 429.983 406.5 429.919 406.5H429.307C429.211 406.5 429.139 406.476 429.091 406.428C429.051 406.38 429.023 406.336 429.007 406.296L428.347 404.592H424.411L423.751 406.296C423.743 406.336 423.715 406.38 423.667 406.428C423.619 406.476 423.547 406.5 423.451 406.5H422.839ZM424.759 403.56H427.999L426.379 399.3L424.759 403.56ZM432.664 406.5C432.584 406.5 432.516 406.476 432.46 406.428C432.412 406.372 432.388 406.304 432.388 406.224V399.168H430.084C430.004 399.168 429.936 399.144 429.88 399.096C429.832 399.04 429.808 398.972 429.808 398.892V398.388C429.808 398.3 429.832 398.232 429.88 398.184C429.936 398.128 430.004 398.1 430.084 398.1H435.868C435.956 398.1 436.024 398.128 436.072 398.184C436.128 398.232 436.156 398.3 436.156 398.388V398.892C436.156 398.972 436.128 399.04 436.072 399.096C436.024 399.144 435.956 399.168 435.868 399.168H433.576V406.224C433.576 406.304 433.548 406.372 433.492 406.428C433.444 406.476 433.376 406.5 433.288 406.5H432.664ZM437.777 406.5C437.689 406.5 437.621 406.476 437.573 406.428C437.525 406.372 437.501 406.304 437.501 406.224V398.376C437.501 398.296 437.525 398.232 437.573 398.184C437.621 398.128 437.689 398.1 437.777 398.1H438.413C438.493 398.1 438.557 398.128 438.605 398.184C438.661 398.232 438.689 398.296 438.689 398.376V406.224C438.689 406.304 438.661 406.372 438.605 406.428C438.557 406.476 438.493 406.5 438.413 406.5H437.777ZM443.794 406.62C443.114 406.62 442.53 406.504 442.042 406.272C441.554 406.032 441.178 405.668 440.914 405.18C440.65 404.684 440.502 404.064 440.47 403.32C440.462 402.968 440.458 402.632 440.458 402.312C440.458 401.984 440.462 401.644 440.47 401.292C440.502 400.556 440.654 399.944 440.926 399.456C441.206 398.96 441.59 398.592 442.078 398.352C442.574 398.104 443.146 397.98 443.794 397.98C444.45 397.98 445.022 398.104 445.51 398.352C446.006 398.592 446.394 398.96 446.674 399.456C446.954 399.944 447.106 400.556 447.13 401.292C447.146 401.644 447.154 401.984 447.154 402.312C447.154 402.632 447.146 402.968 447.13 403.32C447.106 404.064 446.958 404.684 446.686 405.18C446.422 405.668 446.046 406.032 445.558 406.272C445.07 406.504 444.482 406.62 443.794 406.62ZM443.794 405.6C444.41 405.6 444.91 405.416 445.294 405.048C445.686 404.68 445.898 404.084 445.93 403.26C445.946 402.9 445.954 402.58 445.954 402.3C445.954 402.012 445.946 401.692 445.93 401.34C445.914 400.788 445.81 400.34 445.618 399.996C445.434 399.652 445.186 399.4 444.874 399.24C444.562 399.08 444.202 399 443.794 399C443.402 399 443.05 399.08 442.738 399.24C442.426 399.4 442.174 399.652 441.982 399.996C441.798 400.34 441.694 400.788 441.67 401.34C441.662 401.692 441.658 402.012 441.658 402.3C441.658 402.58 441.662 402.9 441.67 403.26C441.702 404.084 441.914 404.68 442.306 405.048C442.698 405.416 443.194 405.6 443.794 405.6ZM449.179 406.5C449.091 406.5 449.023 406.476 448.975 406.428C448.927 406.372 448.903 406.304 448.903 406.224V398.388C448.903 398.3 448.927 398.232 448.975 398.184C449.023 398.128 449.091 398.1 449.179 398.1H449.731C449.827 398.1 449.899 398.124 449.947 398.172C449.995 398.212 450.023 398.244 450.031 398.268L454.015 404.388V398.388C454.015 398.3 454.039 398.232 454.087 398.184C454.135 398.128 454.203 398.1 454.291 398.1H454.867C454.955 398.1 455.023 398.128 455.071 398.184C455.127 398.232 455.155 398.3 455.155 398.388V406.212C455.155 406.292 455.127 406.36 455.071 406.416C455.023 406.472 454.959 406.5 454.879 406.5H454.303C454.215 406.5 454.147 406.476 454.099 406.428C454.059 406.38 454.031 406.348 454.015 406.332L450.043 400.272V406.224C450.043 406.304 450.015 406.372 449.959 406.428C449.911 406.476 449.843 406.5 449.755 406.5H449.179ZM459.935 406.62C459.239 406.62 458.655 406.516 458.183 406.308C457.711 406.092 457.347 405.816 457.091 405.48C456.843 405.136 456.711 404.772 456.695 404.388C456.695 404.324 456.719 404.268 456.767 404.22C456.823 404.164 456.887 404.136 456.959 404.136H457.571C457.667 404.136 457.739 404.16 457.787 404.208C457.835 404.256 457.867 404.312 457.883 404.376C457.923 404.568 458.019 404.76 458.171 404.952C458.331 405.136 458.551 405.292 458.831 405.42C459.119 405.54 459.487 405.6 459.935 405.6C460.623 405.6 461.127 405.48 461.447 405.24C461.775 404.992 461.939 404.664 461.939 404.256C461.939 403.976 461.851 403.752 461.675 403.584C461.507 403.408 461.247 403.252 460.895 403.116C460.543 402.98 460.087 402.832 459.527 402.672C458.943 402.504 458.459 402.32 458.075 402.12C457.691 401.92 457.403 401.672 457.211 401.376C457.027 401.08 456.935 400.704 456.935 400.248C456.935 399.816 457.051 399.432 457.283 399.096C457.515 398.752 457.847 398.48 458.279 398.28C458.719 398.08 459.251 397.98 459.875 397.98C460.371 397.98 460.803 398.048 461.171 398.184C461.547 398.312 461.859 398.488 462.107 398.712C462.355 398.928 462.543 399.164 462.671 399.42C462.799 399.668 462.867 399.912 462.875 400.152C462.875 400.208 462.855 400.264 462.815 400.32C462.775 400.368 462.711 400.392 462.623 400.392H461.987C461.931 400.392 461.871 400.376 461.807 400.344C461.751 400.312 461.707 400.252 461.675 400.164C461.627 399.836 461.443 399.56 461.123 399.336C460.803 399.112 460.387 399 459.875 399C459.355 399 458.931 399.1 458.603 399.3C458.283 399.5 458.123 399.812 458.123 400.236C458.123 400.508 458.199 400.736 458.351 400.92C458.503 401.096 458.743 401.252 459.071 401.388C459.399 401.524 459.827 401.668 460.355 401.82C460.995 401.996 461.519 402.184 461.927 402.384C462.335 402.576 462.635 402.82 462.827 403.116C463.027 403.404 463.127 403.776 463.127 404.232C463.127 404.736 462.995 405.168 462.731 405.528C462.467 405.88 462.095 406.152 461.615 406.344C461.143 406.528 460.583 406.62 459.935 406.62Z'
          fill='white'
        />
        <rect
          x='214.469'
          y='195.089'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='218.469' cy='199.089' r='4' fill='#FFA97F' />
        <rect
          x='196.002'
          y='188.677'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='200.002' cy='192.677' r='4' fill='#FFA97F' />
        <rect
          x='232.39'
          y='156.993'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='236.39' cy='160.993' r='4' fill='#FFA97F' />
        <rect
          x='213.923'
          y='157.815'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='217.923' cy='161.815' r='4' fill='#FFA97F' />
        <rect
          x='626.238'
          y='210.406'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='630.238' cy='214.406' r='4' fill='#FFA4D2' />
        <rect
          x='617.799'
          y='188.633'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='621.799' cy='192.633' r='4' fill='#FFA4D2' />
        <rect
          x='615.771'
          y='234.901'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='619.771' cy='238.901' r='4' fill='#FFA4D2' />
        <rect
          x='607.331'
          y='213.127'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='611.331' cy='217.127' r='4' fill='#FFA4D2' />
        <rect
          x='659.172'
          y='280.715'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='663.172' cy='284.715' r='4' fill='#FFA4D2' />
        <rect
          x='639.882'
          y='184.267'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='643.882' cy='188.267' r='4' fill='#FFA4D2' />
        <rect
          x='609.771'
          y='374.706'
          width='20'
          height='20'
          rx='10'
          stroke='#293950'
        />
        <circle cx='619.771' cy='384.706' r='10' fill='#FFA4D2' />
        <rect
          x='590.452'
          y='277.245'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='594.452' cy='281.245' r='4' fill='#FFA4D2' />
        <rect
          x='547.051'
          y='369.326'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='551.051' cy='373.326' r='4' fill='#FFA4D2' />
        <rect x='653' y='238.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='657' cy='242.5' r='4' fill='#FFA4D2' />
        <rect
          x='649.527'
          y='259.013'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='653.527' cy='263.013' r='4' fill='#FFA4D2' />
        <rect x='649' y='312.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='653' cy='316.5' r='4' fill='#FFA4D2' />
        <rect
          x='697.368'
          y='355.682'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='701.368' cy='359.682' r='4' fill='#FFA4D2' />
        <rect x='667' y='386.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='671' cy='390.5' r='4' fill='#FFA4D2' />
        <rect
          x='666.405'
          y='367.926'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='670.405' cy='371.926' r='4' fill='#FFA4D2' />
        <rect
          x='698.957'
          y='370.63'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='702.957' cy='374.63' r='4' fill='#FFA4D2' />
        <rect
          x='723.508'
          y='408.189'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='727.508' cy='412.189' r='4' fill='#FFA4D2' />
        <rect
          x='707.508'
          y='408.189'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='711.508' cy='412.189' r='4' fill='#FFA4D2' />
        <rect
          x='550.508'
          y='405.189'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='557.508' cy='412.189' r='7' fill='#FFA4D2' />
        <rect
          x='567.508'
          y='402.189'
          width='20'
          height='20'
          rx='10'
          stroke='#293950'
        />
        <circle cx='577.508' cy='412.189' r='10' fill='#FFA4D2' />
        <rect
          x='725.48'
          y='328.62'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='729.48' cy='332.62' r='4' fill='#FFA4D2' />
        <rect x='663' y='328.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='667' cy='332.5' r='4' fill='#FFA4D2' />
        <rect
          x='624.209'
          y='301.357'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='628.209' cy='305.357' r='4' fill='#FFA4D2' />
        <rect x='668' y='344.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='672' cy='348.5' r='4' fill='#FFA4D2' />
        <rect x='659' y='245.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='663' cy='249.5' r='4' fill='#FFA4D2' />
        <rect x='665' y='254.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='669' cy='258.5' r='4' fill='#FFA4D2' />
        <rect x='612' y='289.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='616' cy='293.5' r='4' fill='#FFA4D2' />
        <rect x='622' y='285.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='626' cy='289.5' r='4' fill='#FFA4D2' />
        <rect x='669' y='263.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='673' cy='267.5' r='4' fill='#FFA4D2' />
        <rect
          x='635.883'
          y='258.63'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='639.883' cy='262.63' r='4' fill='#FFA4D2' />
        <rect
          x='679.284'
          y='304.444'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='683.284' cy='308.444' r='4' fill='#FFA4D2' />
        <rect
          x='625.416'
          y='344.914'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='629.416' cy='348.914' r='4' fill='#FFA4D2' />
        <rect
          x='631.06'
          y='343.171'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='635.06' cy='347.171' r='4' fill='#FFA4D2' />
        <rect
          x='709.425'
          y='338.802'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='713.425' cy='342.802' r='4' fill='#FFA4D2' />
        <rect x='633' y='280.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='637' cy='284.5' r='4' fill='#FFA4D2' />
        <rect x='713' y='348.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='717' cy='352.5' r='4' fill='#FFA4D2' />
        <rect x='612' y='328.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='616' cy='332.5' r='4' fill='#FFA4D2' />
        <rect
          x='562.724'
          y='367.216'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='566.724' cy='371.216' r='4' fill='#FFA4D2' />
        <rect
          x='562.724'
          y='353.727'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='566.724' cy='357.727' r='4' fill='#FFA4D2' />
        <rect
          x='577.808'
          y='304.693'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='584.808' cy='311.693' r='7' fill='#FFA4D2' />
        <rect x='584' y='328.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='588' cy='332.5' r='4' fill='#FFA4D2' />
        <rect
          x='588.864'
          y='338.348'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='592.864' cy='342.348' r='4' fill='#FFA4D2' />
        <rect x='592' y='349.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='596' cy='353.5' r='4' fill='#FFA4D2' />
        <rect
          x='635.061'
          y='317.337'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='639.061' cy='321.337' r='4' fill='#FFA4D2' />
        <rect
          x='690.518'
          y='337.98'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='694.518' cy='341.98' r='4' fill='#FFA4D2' />
        <rect
          x='547.873'
          y='321.924'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='551.873' cy='325.924' r='4' fill='#FFA4D2' />
        <rect x='655' y='376.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='659' cy='380.5' r='4' fill='#FFA4D2' />
        <rect x='652' y='363.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='656' cy='367.5' r='4' fill='#FFA4D2' />
        <rect x='657' y='387.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='661' cy='391.5' r='4' fill='#FFA4D2' />
        <rect
          x='730.303'
          y='292.455'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='734.303' cy='296.455' r='4' fill='#FFA4D2' />
        <rect
          x='691.34'
          y='382.366'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='695.34' cy='386.366' r='4' fill='#FFA4D2' />
        <rect
          x='725.303'
          y='280.306'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='729.303' cy='284.306' r='4' fill='#FFA4D2' />
        <rect x='678' y='361.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='682' cy='365.5' r='4' fill='#FFA4D2' />
        <rect
          x='713.425'
          y='267.202'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='717.425' cy='271.202' r='4' fill='#FFA4D2' />
        <rect x='693' y='246.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='697' cy='250.5' r='4' fill='#FFA4D2' />
        <rect x='704' y='241.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='708' cy='245.5' r='4' fill='#FFA4D2' />
        <rect
          x='639.882'
          y='332.856'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='643.882' cy='336.856' r='4' fill='#FFA4D2' />
        <rect x='624' y='323.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='628' cy='327.5' r='4' fill='#FFA4D2' />
        <rect
          x='497.021'
          y='138.325'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='501.021' cy='142.325' r='4' fill='#F6A6A4' />
        <rect
          x='569.809'
          y='95.6321'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='576.809' cy='102.632' r='7' fill='#F6A6A4' />
        <rect
          x='366.058'
          y='222.475'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='370.058' cy='226.475' r='4' fill='#F6A6A4' />
        <rect
          x='421.176'
          y='253.646'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='425.176' cy='257.646' r='4' fill='#F6A6A4' />
        <rect
          x='542.146'
          y='186.86'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='546.146' cy='190.86' r='4' fill='#F6A6A4' />
        <rect
          x='324.686'
          y='224.752'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='328.686' cy='228.752' r='4' fill='#F6A6A4' />
        <rect
          x='465.636'
          y='104.699'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='469.636' cy='108.699' r='4' fill='#F6A6A4' />
        <rect
          x='443.86'
          y='174.703'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='447.86' cy='178.703' r='4' fill='#F6A6A4' />
        <rect
          x='529.912'
          y='194.559'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='533.912' cy='198.559' r='4' fill='#F6A6A4' />
        <rect
          x='285'
          y='138.749'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='289' cy='142.749' r='4' fill='#F6A6A4' />
        <rect
          x='541.247'
          y='230.713'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='545.247' cy='234.713' r='4' fill='#F6A6A4' />
        <rect
          x='378.062'
          y='100.018'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='382.062' cy='104.018' r='4' fill='#F6A6A4' />
        <rect
          x='332.312'
          y='216.2'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='336.312' cy='220.2' r='4' fill='#F6A6A4' />
        <rect
          x='540.312'
          y='205.647'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='544.312' cy='209.647' r='4' fill='#F6A6A4' />
        <rect
          x='504.642'
          y='158.428'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='508.642' cy='162.428' r='4' fill='#F6A6A4' />
        <rect x='533' y='144.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='537' cy='148.5' r='4' fill='#F6A6A4' />
        <rect
          x='519.086'
          y='130.421'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='523.086' cy='134.421' r='4' fill='#F6A6A4' />
        <rect
          x='372.11'
          y='252.824'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='376.11' cy='256.824' r='4' fill='#F6A6A4' />
        <rect
          x='544.804'
          y='217.085'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='548.804' cy='221.085' r='4' fill='#F6A6A4' />
        <rect
          x='503.623'
          y='112.13'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='507.623' cy='116.13' r='4' fill='#F6A6A4' />
        <rect
          x='481.902'
          y='226.475'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='485.902' cy='230.475' r='4' fill='#F6A6A4' />
        <rect
          x='358.109'
          y='126.051'
          width='20'
          height='20'
          rx='10'
          stroke='#293950'
        />
        <circle cx='368.109' cy='136.051' r='10' fill='#F6A6A4' />
        <rect
          x='446.314'
          y='156.562'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='450.314' cy='160.562' r='4' fill='#F6A6A4' />
        <rect
          x='350.81'
          y='237.154'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='354.81' cy='241.154' r='4' fill='#F6A6A4' />
        <rect
          x='300.259'
          y='212.975'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='304.259' cy='216.975' r='4' fill='#F6A6A4' />
        <rect x='560' y='155.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='564' cy='159.5' r='4' fill='#F6A6A4' />
        <rect
          x='381.98'
          y='135.8'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='385.98' cy='139.8' r='4' fill='#F6A6A4' />
        <rect
          x='378.91'
          y='185.472'
          width='20'
          height='20'
          rx='10'
          stroke='#293950'
        />
        <circle cx='388.91' cy='195.472' r='10' fill='#F6A6A4' />
        <rect
          x='568.587'
          y='166.79'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='572.587' cy='170.79' r='4' fill='#F6A6A4' />
        <rect
          x='374.911'
          y='110.438'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='378.911' cy='114.438' r='4' fill='#F6A6A4' />
        <rect x='291' y='81.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='295' cy='85.5' r='4' fill='#F6A6A4' />
        <rect
          x='317.138'
          y='169.27'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='321.138' cy='173.27' r='4' fill='#F6A6A4' />
        <rect
          x='329.015'
          y='236.516'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='333.015' cy='240.516' r='4' fill='#F6A6A4' />
        <rect
          x='474.082'
          y='236.476'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='481.082' cy='243.476' r='7' fill='#F6A6A4' />
        <rect
          x='378.909'
          y='221.977'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='382.909' cy='225.977' r='4' fill='#F6A6A4' />
        <rect x='518' y='181.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='522' cy='185.5' r='4' fill='#F6A6A4' />
        <rect
          x='499.659'
          y='94.3745'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='503.659' cy='98.3745' r='4' fill='#F6A6A4' />
        <rect x='548' y='178.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='552' cy='182.5' r='4' fill='#F6A6A4' />
        <rect x='404' y='270.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='408' cy='274.5' r='4' fill='#F6A6A4' />
        <rect
          x='538.984'
          y='164.981'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='542.984' cy='168.981' r='4' fill='#F6A6A4' />
        <rect
          x='558.547'
          y='193.891'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='562.547' cy='197.891' r='4' fill='#F6A6A4' />
        <rect
          x='328.946'
          y='121.499'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='332.946' cy='125.499' r='4' fill='#F6A6A4' />
        <rect
          x='387.048'
          y='146.156'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='391.048' cy='150.156' r='4' fill='#F6A6A4' />
        <rect
          x='306.258'
          y='200.624'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='310.258' cy='204.624' r='4' fill='#F6A6A4' />
        <rect
          x='559.186'
          y='132.02'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='563.186' cy='136.02' r='4' fill='#F6A6A4' />
        <rect
          x='411.062'
          y='234.727'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='415.062' cy='238.727' r='4' fill='#F6A6A4' />
        <rect
          x='377.98'
          y='173.061'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='381.98' cy='177.061' r='4' fill='#F6A6A4' />
        <rect x='552' y='248.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='556' cy='252.5' r='4' fill='#F6A6A4' />
        <rect
          x='404.635'
          y='249.263'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='408.635' cy='253.263' r='4' fill='#F6A6A4' />
        <rect
          x='302.291'
          y='108.3'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='306.291' cy='112.3' r='4' fill='#F6A6A4' />
        <rect
          x='306.78'
          y='100.09'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='310.78' cy='104.09' r='4' fill='#F6A6A4' />
        <rect x='325' y='110.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='329' cy='114.5' r='4' fill='#F6A6A4' />
        <rect x='563' y='256.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='567' cy='260.5' r='4' fill='#F6A6A4' />
        <rect x='546' y='168.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='550' cy='172.5' r='4' fill='#F6A6A4' />
        <rect
          x='365.711'
          y='239.122'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='369.711' cy='243.122' r='4' fill='#F6A6A4' />
        <rect
          x='299.502'
          y='89.7993'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='303.502' cy='93.7993' r='4' fill='#F6A6A4' />
        <rect
          x='573.656'
          y='154.148'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='577.656' cy='158.148' r='4' fill='#F6A6A4' />
        <rect
          x='302.182'
          y='188.77'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='306.182' cy='192.77' r='4' fill='#F6A6A4' />
        <rect
          x='414.279'
          y='217.652'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='418.279' cy='221.652' r='4' fill='#F6A6A4' />
        <rect
          x='410.281'
          y='286.342'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='414.281' cy='290.342' r='4' fill='#F6A6A4' />
        <rect
          x='294.585'
          y='117.332'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='298.585' cy='121.332' r='4' fill='#F6A6A4' />
        <rect
          x='337.561'
          y='130.999'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='341.561' cy='134.999' r='4' fill='#F6A6A4' />
        <rect
          x='395.533'
          y='233.15'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='399.533' cy='237.15' r='4' fill='#F6A6A4' />
        <rect
          x='489.111'
          y='123.853'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='493.111' cy='127.853' r='4' fill='#F6A6A4' />
        <rect
          x='219.497'
          y='247.029'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='223.497' cy='251.029' r='4' fill='#FFA97F' />
        <rect x='124' y='239.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='128' cy='243.5' r='4' fill='#FFA97F' />
        <rect
          x='208.143'
          y='215.196'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='212.143' cy='219.196' r='4' fill='#FFA97F' />
        <rect
          x='224'
          y='292.5'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='231' cy='299.5' r='7' fill='#FFA97F' />
        <rect
          x='245.743'
          y='348.964'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='249.743' cy='352.964' r='4' fill='#FFA97F' />
        <rect
          x='180.602'
          y='342.714'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='184.602' cy='346.714' r='4' fill='#FFA97F' />
        <rect
          x='195.857'
          y='391.246'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='199.857' cy='395.246' r='4' fill='#FFA97F' />
        <rect
          x='295.98'
          y='400.069'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='299.98' cy='404.069' r='4' fill='#FFA97F' />
        <rect
          x='258.678'
          y='254.369'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='262.678' cy='258.369' r='4' fill='#FFA97F' />
        <rect x='164' y='297.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='168' cy='301.5' r='4' fill='#FFA97F' />
        <rect
          x='255.183'
          y='373.347'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='259.183' cy='377.347' r='4' fill='#FFA97F' />
        <rect
          x='284.698'
          y='394.863'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='288.698' cy='398.863' r='4' fill='#FFA97F' />
        <rect
          x='224.248'
          y='345.028'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='228.248' cy='349.028' r='4' fill='#FFA97F' />
        <rect x='257' y='293.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='261' cy='297.5' r='4' fill='#FFA97F' />
        <rect x='145' y='213.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='149' cy='217.5' r='4' fill='#FFA97F' />
        <rect
          x='225.959'
          y='354.088'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='229.959' cy='358.088' r='4' fill='#FFA97F' />
        <rect
          x='201.922'
          y='246.192'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='205.922' cy='250.192' r='4' fill='#FFA97F' />
        <rect
          x='183.475'
          y='365.681'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='187.475' cy='369.681' r='4' fill='#FFA97F' />
        <rect
          x='276.83'
          y='369.925'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='280.83' cy='373.925' r='4' fill='#FFA97F' />
        <rect
          x='147.999'
          y='369.395'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='151.999' cy='373.395' r='4' fill='#FFA97F' />
        <rect
          x='227.437'
          y='385.83'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='231.437' cy='389.83' r='4' fill='#FFA97F' />
        <rect
          x='249.857'
          y='264.824'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='253.857' cy='268.824' r='4' fill='#FFA97F' />
        <rect
          x='159.41'
          y='391.246'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='163.41' cy='395.246' r='4' fill='#FFA97F' />
        <rect
          x='152.168'
          y='350.795'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='156.168' cy='354.795' r='4' fill='#FFA97F' />
        <rect
          x='261.223'
          y='365.808'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='265.223' cy='369.808' r='4' fill='#FFA97F' />
        <rect
          x='206.982'
          y='231.625'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='210.982' cy='235.625' r='4' fill='#FFA97F' />
        <rect
          x='240.806'
          y='330.693'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='244.806' cy='334.693' r='4' fill='#FFA97F' />
        <rect
          x='132.491'
          y='328.62'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='136.491' cy='332.62' r='4' fill='#FFA97F' />
        <rect
          x='202.479'
          y='374.188'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='206.479' cy='378.188' r='4' fill='#FFA97F' />
        <rect
          x='131.973'
          y='228.972'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='135.973' cy='232.972' r='4' fill='#FFA97F' />
        <rect
          x='259.446'
          y='213.513'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='263.446' cy='217.513' r='4' fill='#FFA97F' />
        <rect x='196' y='301.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='200' cy='305.5' r='4' fill='#FFA97F' />
        <rect
          x='156.085'
          y='316.263'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='160.085' cy='320.263' r='4' fill='#FFA97F' />
        <rect
          x='137.618'
          y='307.441'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='141.618' cy='311.441' r='4' fill='#FFA97F' />
        <rect
          x='171.505'
          y='351.886'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='175.505' cy='355.886' r='4' fill='#FFA97F' />
        <rect x='141' y='235.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='145' cy='239.5' r='4' fill='#FFA97F' />
        <rect x='202' y='312.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='206' cy='316.5' r='4' fill='#FFA97F' />
        <rect
          x='161.778'
          y='344.209'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='165.778' cy='348.209' r='4' fill='#FFA97F' />
        <rect x='209' y='297.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='213' cy='301.5' r='4' fill='#FFA97F' />
        <rect
          x='258.024'
          y='385.83'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='262.024' cy='389.83' r='4' fill='#FFA97F' />
        <rect
          x='231.508'
          y='240.26'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='235.508' cy='244.26' r='4' fill='#FFA97F' />
        <rect x='222' y='362.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='226' cy='366.5' r='4' fill='#FFA97F' />
        <rect
          x='148.621'
          y='390.424'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='152.621' cy='394.424' r='4' fill='#FFA97F' />
        <rect x='267' y='298.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='271' cy='302.5' r='4' fill='#FFA97F' />
        <rect
          x='281.65'
          y='310.868'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='285.65' cy='314.868' r='4' fill='#FFA97F' />
        <rect x='212' y='359.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='216' cy='363.5' r='4' fill='#FFA97F' />
        <rect
          x='174.538'
          y='364.271'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='178.538' cy='368.271' r='4' fill='#FFA97F' />
        <rect
          x='299.903'
          y='384.566'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='303.903' cy='388.566' r='4' fill='#FFA97F' />
        <rect
          x='188.656'
          y='386.729'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='192.656' cy='390.729' r='4' fill='#FFA97F' />
        <rect x='263' y='283.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='267' cy='287.5' r='4' fill='#FFA97F' />
        <rect
          x='144.947'
          y='327.069'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='148.947' cy='331.069' r='4' fill='#FFA97F' />
        <rect
          x='278.098'
          y='249.385'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='282.098' cy='253.385' r='4' fill='#FFA97F' />
        <rect
          x='249.599'
          y='385.83'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='253.599' cy='389.83' r='4' fill='#FFA97F' />
        <rect
          x='209.24'
          y='389.782'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='213.24' cy='393.782' r='4' fill='#FFA97F' />
        <rect
          x='293.79'
          y='339.318'
          width='20'
          height='20'
          rx='10'
          stroke='#293950'
        />
        <circle cx='303.79' cy='349.318' r='10' fill='#FFA97F' />
        <rect
          x='225.353'
          y='233.795'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='229.353' cy='237.795' r='4' fill='#FFA97F' />
        <rect
          x='257.645'
          y='230.119'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='261.645' cy='234.119' r='4' fill='#FFA97F' />
        <rect
          x='263.382'
          y='262.993'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='267.382' cy='266.993' r='4' fill='#FFA97F' />
        <rect
          x='137.649'
          y='342.273'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='141.649' cy='346.273' r='4' fill='#FFA97F' />
        <rect
          x='168.084'
          y='287.085'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='172.084' cy='291.085' r='4' fill='#FFA97F' />
        <rect x='187' y='315.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='191' cy='319.5' r='4' fill='#FFA97F' />
        <rect
          x='241.628'
          y='241.869'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='245.628' cy='245.869' r='4' fill='#FFA97F' />
        <rect x='169' y='320.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='173' cy='324.5' r='4' fill='#FFA97F' />
        <rect
          x='201.475'
          y='356.359'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='205.475' cy='360.359' r='4' fill='#FFA97F' />
        <rect
          x='255.19'
          y='243.352'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='259.19' cy='247.352' r='4' fill='#FFA97F' />
        <rect
          x='310.872'
          y='311.404'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='314.872' cy='315.404' r='4' fill='#FFA97F' />
        <rect
          x='339.807'
          y='292.114'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='343.807' cy='296.114' r='4' fill='#FFA97F' />
        <rect x='198' y='227.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='202' cy='231.5' r='4' fill='#FFA97F' />
        <rect
          x='281.026'
          y='226.762'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='285.026' cy='230.762' r='4' fill='#FFA97F' />
        <rect
          x='174.474'
          y='275.98'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='178.474' cy='279.98' r='4' fill='#FFA97F' />
        <rect x='245' y='369.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='249' cy='373.5' r='4' fill='#FFA97F' />
        <rect
          x='152.715'
          y='369.305'
          width='20'
          height='20'
          rx='10'
          stroke='#293950'
        />
        <circle cx='162.715' cy='379.305' r='10' fill='#FFA97F' />
        <rect
          x='213.645'
          y='343.064'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='217.645' cy='347.064' r='4' fill='#FFA97F' />
        <rect x='237' y='219.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='241' cy='223.5' r='4' fill='#FFA97F' />
        <rect
          x='127'
          y='358.531'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='134' cy='365.531' r='7' fill='#FFA97F' />
        <rect
          x='254.645'
          y='322.908'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='261.645' cy='329.908' r='7' fill='#FFA97F' />
        <rect
          x='240.806'
          y='320.431'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='244.806' cy='324.431' r='4' fill='#FFA97F' />
        <rect
          x='204.823'
          y='191.472'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='208.823' cy='195.472' r='4' fill='#FFA97F' />
        <rect
          x='254.09'
          y='166.638'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='258.09' cy='170.638' r='4' fill='#FFA97F' />
        <rect x='687' y='326.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='691' cy='330.5' r='4' fill='#FFA4D2' />
        <rect
          x='668.815'
          y='214.406'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='672.815' cy='218.406' r='4' fill='#FFA4D2' />
        <rect x='676' y='274.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='680' cy='278.5' r='4' fill='#FFA4D2' />
        <rect x='679' y='341.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='683' cy='345.5' r='4' fill='#FFA4D2' />
        <rect
          x='692.928'
          y='291.565'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='696.928' cy='295.565' r='4' fill='#FFA4D2' />
        <rect x='698' y='232.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='702' cy='236.5' r='4' fill='#FFA4D2' />
        <rect
          x='399.555'
          y='144.95'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='406.555' cy='151.95' r='7' fill='#F6A6A4' />
        <rect
          x='541.603'
          y='112.546'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='545.603' cy='116.546' r='4' fill='#F6A6A4' />
        <rect
          x='516.773'
          y='248.982'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='520.773' cy='252.982' r='4' fill='#F6A6A4' />
        <rect
          x='570'
          y='209.5'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='577' cy='216.5' r='7' fill='#F6A6A4' />
        <rect
          x='429.589'
          y='173.476'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='433.589' cy='177.476' r='4' fill='#F6A6A4' />
        <rect
          x='529.594'
          y='89.8118'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='533.594' cy='93.8118' r='4' fill='#F6A6A4' />
        <rect
          x='331.8'
          y='173.268'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='335.8' cy='177.268' r='4' fill='#F6A6A4' />
        <rect
          x='370.91'
          y='154.156'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='374.91' cy='158.156' r='4' fill='#F6A6A4' />
        <rect
          x='143.699'
          y='289.675'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='150.699' cy='296.675' r='7' fill='#FFA97F' />
        <rect x='201' y='292.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='205' cy='296.5' r='4' fill='#FFA97F' />
        <rect
          x='189.902'
          y='276.846'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='193.902' cy='280.846' r='4' fill='#FFA97F' />
        <rect
          x='277.379'
          y='331.778'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='281.379' cy='335.778' r='4' fill='#FFA97F' />
        <rect
          x='272.784'
          y='289.016'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='276.784' cy='293.016' r='4' fill='#FFA97F' />
        <rect x='240' y='259.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='244' cy='263.5' r='4' fill='#FFA97F' />
        <rect
          x='215.616'
          y='268.406'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='219.616' cy='272.406' r='4' fill='#FFA97F' />
        <rect
          x='270.296'
          y='357.459'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='274.296' cy='361.459' r='4' fill='#FFA97F' />
        <rect
          x='252.469'
          y='345.332'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='256.469' cy='349.332' r='4' fill='#FFA97F' />
        <rect
          x='275.054'
          y='377.986'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='279.054' cy='381.986' r='4' fill='#FFA97F' />
        <rect x='180' y='266.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='184' cy='270.5' r='4' fill='#FFA97F' />
        <rect
          x='232.637'
          y='286.342'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='236.637' cy='290.342' r='4' fill='#FFA97F' />
        <rect x='137' y='261.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='141' cy='265.5' r='4' fill='#FFA97F' />
        <rect x='183' y='324.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='187' cy='328.5' r='4' fill='#FFA97F' />
        <rect
          x='183'
          y='254.5'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='190' cy='261.5' r='7' fill='#FFA97F' />
        <rect
          x='188.802'
          y='222.404'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='192.802' cy='226.404' r='4' fill='#FFA97F' />
        <rect
          x='176.544'
          y='305.825'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='180.544' cy='309.825' r='4' fill='#FFA97F' />
        <rect
          x='291.582'
          y='321.048'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='295.582' cy='325.048' r='4' fill='#FFA97F' />
        <rect
          x='320.517'
          y='292.114'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='324.517' cy='296.114' r='4' fill='#FFA97F' />
        <rect
          x='513.441'
          y='140.143'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='517.441' cy='144.143' r='4' fill='#F6A6A4' />
        <rect
          x='449'
          y='211.5'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='456' cy='218.5' r='7' fill='#F6A6A4' />
        <rect
          x='485.804'
          y='218.244'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='489.804' cy='222.244' r='4' fill='#F6A6A4' />
        <rect
          x='526.418'
          y='150.242'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='530.418' cy='154.242' r='4' fill='#F6A6A4' />
        <rect x='426' y='96.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='430' cy='100.5' r='4' fill='#F6A6A4' />
        <rect
          x='546.187'
          y='237.953'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='550.187' cy='241.953' r='4' fill='#F6A6A4' />
        <rect
          x='447.553'
          y='130.132'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='451.553' cy='134.132' r='4' fill='#F6A6A4' />
        <rect x='435' y='122.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='439' cy='126.5' r='4' fill='#F6A6A4' />
        <rect
          x='452.444'
          y='110.038'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='456.444' cy='114.038' r='4' fill='#F6A6A4' />
        <rect
          x='504.503'
          y='200.55'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='508.503' cy='204.55' r='4' fill='#F6A6A4' />
        <rect
          x='435.465'
          y='105.988'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='439.465' cy='109.988' r='4' fill='#F6A6A4' />
        <rect x='424' y='82.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='428' cy='86.5' r='4' fill='#F6A6A4' />
        <rect
          x='439.61'
          y='166.165'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='443.61' cy='170.165' r='4' fill='#F6A6A4' />
        <rect
          x='519.104'
          y='222.408'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='523.104' cy='226.408' r='4' fill='#F6A6A4' />
        <rect
          x='441.209'
          y='225.326'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='445.209' cy='229.326' r='4' fill='#F6A6A4' />
        <rect
          x='428.33'
          y='207.494'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='432.33' cy='211.494' r='4' fill='#F6A6A4' />
        <rect x='554' y='229.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='558' cy='233.5' r='4' fill='#F6A6A4' />
        <rect
          x='417.524'
          y='200.454'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='421.524' cy='204.454' r='4' fill='#F6A6A4' />
        <rect
          x='473.081'
          y='252.824'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='477.081' cy='256.824' r='4' fill='#F6A6A4' />
        <rect
          x='468.902'
          y='266.908'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='472.902' cy='270.908' r='4' fill='#F6A6A4' />
        <rect
          x='490.693'
          y='203.176'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='494.693' cy='207.176' r='4' fill='#F6A6A4' />
        <rect x='444' y='186.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='448' cy='190.5' r='4' fill='#F6A6A4' />
        <rect
          x='434.486'
          y='155.065'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='438.486' cy='159.065' r='4' fill='#F6A6A4' />
        <rect
          x='425.538'
          y='116.202'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='429.538' cy='120.202' r='4' fill='#F6A6A4' />
        <rect
          x='480.119'
          y='161.931'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='487.119' cy='168.931' r='7' fill='#F6A6A4' />
        <rect
          x='462.089'
          y='74.5'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='466.089' cy='78.5' r='4' fill='#F6A6A4' />
        <rect
          x='598.922'
          y='200.909'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='605.922' cy='207.909' r='7' fill='#FFA4D2' />
        <rect x='633' y='215.5' width='8' height='8' rx='4' stroke='#293950' />
        <circle cx='637' cy='219.5' r='4' fill='#FFA4D2' />
        <rect
          x='593.48'
          y='226.476'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='600.48' cy='233.476' r='7' fill='#FFA4D2' />
        <rect
          x='394.739'
          y='169.061'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='398.739' cy='173.061' r='4' fill='#F6A6A4' />
        <rect
          x='508.174'
          y='220.609'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='512.174' cy='224.609' r='4' fill='#F6A6A4' />
        <rect
          x='299.902'
          y='265.416'
          width='8'
          height='8'
          rx='4'
          stroke='#293950'
        />
        <circle cx='303.902' cy='269.416' r='4' fill='#FFA97F' />
        <rect
          x='278'
          y='259.5'
          width='14'
          height='14'
          rx='7'
          stroke='#293950'
        />
        <circle cx='285' cy='266.5' r='7' fill='#FFA97F' />
        <path
          d='M388.564 453.62C387.892 453.62 387.312 453.5 386.824 453.26C386.344 453.02 385.972 452.656 385.708 452.168C385.452 451.672 385.324 451.036 385.324 450.26V445.388C385.324 445.3 385.348 445.232 385.396 445.184C385.444 445.128 385.512 445.1 385.6 445.1H386.212C386.3 445.1 386.368 445.128 386.416 445.184C386.472 445.232 386.5 445.3 386.5 445.388V450.284C386.5 451.068 386.684 451.648 387.052 452.024C387.42 452.4 387.924 452.588 388.564 452.588C389.196 452.588 389.696 452.4 390.064 452.024C390.44 451.648 390.628 451.068 390.628 450.284V445.388C390.628 445.3 390.652 445.232 390.7 445.184C390.756 445.128 390.824 445.1 390.904 445.1H391.528C391.608 445.1 391.672 445.128 391.72 445.184C391.776 445.232 391.804 445.3 391.804 445.388V450.26C391.804 451.036 391.672 451.672 391.408 452.168C391.152 452.656 390.784 453.02 390.304 453.26C389.824 453.5 389.244 453.62 388.564 453.62ZM393.942 455.78C393.862 455.78 393.794 455.752 393.738 455.696C393.69 455.648 393.666 455.584 393.666 455.504V447.536C393.666 447.456 393.69 447.392 393.738 447.344C393.794 447.288 393.862 447.26 393.942 447.26H394.494C394.574 447.26 394.638 447.288 394.686 447.344C394.742 447.392 394.77 447.456 394.77 447.536V448.064C394.962 447.8 395.218 447.58 395.538 447.404C395.858 447.228 396.258 447.14 396.738 447.14C397.186 447.14 397.566 447.216 397.878 447.368C398.198 447.52 398.458 447.728 398.658 447.992C398.866 448.256 399.022 448.556 399.126 448.892C399.23 449.228 399.286 449.588 399.294 449.972C399.302 450.1 399.306 450.236 399.306 450.38C399.306 450.524 399.302 450.66 399.294 450.788C399.286 451.164 399.23 451.524 399.126 451.868C399.022 452.204 398.866 452.504 398.658 452.768C398.458 453.024 398.198 453.232 397.878 453.392C397.566 453.544 397.186 453.62 396.738 453.62C396.274 453.62 395.882 453.536 395.562 453.368C395.25 453.192 394.994 452.976 394.794 452.72V455.504C394.794 455.584 394.77 455.648 394.722 455.696C394.674 455.752 394.606 455.78 394.518 455.78H393.942ZM396.486 452.648C396.902 452.648 397.226 452.56 397.458 452.384C397.698 452.2 397.87 451.964 397.974 451.676C398.078 451.38 398.138 451.064 398.154 450.728C398.162 450.496 398.162 450.264 398.154 450.032C398.138 449.696 398.078 449.384 397.974 449.096C397.87 448.8 397.698 448.564 397.458 448.388C397.226 448.204 396.902 448.112 396.486 448.112C396.094 448.112 395.774 448.204 395.526 448.388C395.286 448.572 395.106 448.808 394.986 449.096C394.874 449.376 394.81 449.664 394.794 449.96C394.786 450.088 394.782 450.24 394.782 450.416C394.782 450.592 394.786 450.748 394.794 450.884C394.802 451.164 394.866 451.44 394.986 451.712C395.114 451.984 395.302 452.208 395.55 452.384C395.798 452.56 396.11 452.648 396.486 452.648ZM403.082 453.62C402.642 453.62 402.262 453.544 401.942 453.392C401.622 453.232 401.358 453.02 401.15 452.756C400.95 452.484 400.798 452.176 400.694 451.832C400.598 451.488 400.542 451.124 400.526 450.74C400.518 450.612 400.514 450.492 400.514 450.38C400.514 450.268 400.518 450.148 400.526 450.02C400.542 449.644 400.598 449.284 400.694 448.94C400.798 448.596 400.95 448.288 401.15 448.016C401.358 447.744 401.622 447.532 401.942 447.38C402.262 447.22 402.642 447.14 403.082 447.14C403.554 447.14 403.946 447.224 404.258 447.392C404.57 447.56 404.826 447.768 405.026 448.016V445.256C405.026 445.176 405.05 445.112 405.098 445.064C405.154 445.008 405.222 444.98 405.302 444.98H405.878C405.958 444.98 406.022 445.008 406.07 445.064C406.126 445.112 406.154 445.176 406.154 445.256V453.224C406.154 453.304 406.126 453.372 406.07 453.428C406.022 453.476 405.958 453.5 405.878 453.5H405.338C405.25 453.5 405.182 453.476 405.134 453.428C405.086 453.372 405.062 453.304 405.062 453.224V452.72C404.862 452.976 404.602 453.192 404.282 453.368C403.962 453.536 403.562 453.62 403.082 453.62ZM403.334 452.648C403.734 452.648 404.054 452.556 404.294 452.372C404.534 452.188 404.714 451.956 404.834 451.676C404.954 451.388 405.018 451.096 405.026 450.8C405.034 450.672 405.038 450.52 405.038 450.344C405.038 450.16 405.034 450.004 405.026 449.876C405.018 449.596 404.95 449.32 404.822 449.048C404.702 448.776 404.518 448.552 404.27 448.376C404.03 448.2 403.718 448.112 403.334 448.112C402.926 448.112 402.602 448.204 402.362 448.388C402.122 448.564 401.95 448.8 401.846 449.096C401.742 449.384 401.682 449.696 401.666 450.032C401.658 450.264 401.658 450.496 401.666 450.728C401.682 451.064 401.742 451.38 401.846 451.676C401.95 451.964 402.122 452.2 402.362 452.384C402.602 452.56 402.926 452.648 403.334 452.648ZM409.679 453.62C409.279 453.62 408.915 453.54 408.587 453.38C408.259 453.22 407.995 453.004 407.795 452.732C407.595 452.46 407.495 452.152 407.495 451.808C407.495 451.256 407.719 450.816 408.167 450.488C408.615 450.16 409.199 449.944 409.919 449.84L411.707 449.588V449.24C411.707 448.856 411.595 448.556 411.371 448.34C411.155 448.124 410.799 448.016 410.303 448.016C409.943 448.016 409.651 448.088 409.427 448.232C409.211 448.376 409.059 448.56 408.971 448.784C408.923 448.904 408.839 448.964 408.719 448.964H408.179C408.091 448.964 408.023 448.94 407.975 448.892C407.935 448.836 407.915 448.772 407.915 448.7C407.915 448.58 407.959 448.432 408.047 448.256C408.143 448.08 408.287 447.908 408.479 447.74C408.671 447.572 408.915 447.432 409.211 447.32C409.515 447.2 409.883 447.14 410.315 447.14C410.795 447.14 411.199 447.204 411.527 447.332C411.855 447.452 412.111 447.616 412.295 447.824C412.487 448.032 412.623 448.268 412.703 448.532C412.791 448.796 412.835 449.064 412.835 449.336V453.224C412.835 453.304 412.807 453.372 412.751 453.428C412.703 453.476 412.639 453.5 412.559 453.5H412.007C411.919 453.5 411.851 453.476 411.803 453.428C411.755 453.372 411.731 453.304 411.731 453.224V452.708C411.627 452.852 411.487 452.996 411.311 453.14C411.135 453.276 410.915 453.392 410.651 453.488C410.387 453.576 410.063 453.62 409.679 453.62ZM409.931 452.72C410.259 452.72 410.559 452.652 410.831 452.516C411.103 452.372 411.315 452.152 411.467 451.856C411.627 451.56 411.707 451.188 411.707 450.74V450.404L410.315 450.608C409.747 450.688 409.319 450.824 409.031 451.016C408.743 451.2 408.599 451.436 408.599 451.724C408.599 451.948 408.663 452.136 408.791 452.288C408.927 452.432 409.095 452.54 409.295 452.612C409.503 452.684 409.715 452.72 409.931 452.72ZM416.937 453.5C416.489 453.5 416.125 453.416 415.845 453.248C415.565 453.072 415.361 452.828 415.233 452.516C415.105 452.196 415.041 451.82 415.041 451.388V448.22H414.105C414.025 448.22 413.957 448.196 413.901 448.148C413.853 448.092 413.829 448.024 413.829 447.944V447.536C413.829 447.456 413.853 447.392 413.901 447.344C413.957 447.288 414.025 447.26 414.105 447.26H415.041V445.256C415.041 445.176 415.065 445.112 415.113 445.064C415.169 445.008 415.237 444.98 415.317 444.98H415.881C415.961 444.98 416.025 445.008 416.073 445.064C416.129 445.112 416.157 445.176 416.157 445.256V447.26H417.645C417.725 447.26 417.789 447.288 417.837 447.344C417.893 447.392 417.921 447.456 417.921 447.536V447.944C417.921 448.024 417.893 448.092 417.837 448.148C417.789 448.196 417.725 448.22 417.645 448.22H416.157V451.304C416.157 451.68 416.221 451.976 416.349 452.192C416.477 452.408 416.705 452.516 417.033 452.516H417.765C417.845 452.516 417.909 452.544 417.957 452.6C418.013 452.648 418.041 452.712 418.041 452.792V453.224C418.041 453.304 418.013 453.372 417.957 453.428C417.909 453.476 417.845 453.5 417.765 453.5H416.937ZM421.673 453.62C420.849 453.62 420.193 453.368 419.705 452.864C419.217 452.352 418.949 451.656 418.901 450.776C418.893 450.672 418.889 450.54 418.889 450.38C418.889 450.212 418.893 450.076 418.901 449.972C418.933 449.404 419.065 448.908 419.297 448.484C419.529 448.052 419.845 447.72 420.245 447.488C420.653 447.256 421.129 447.14 421.673 447.14C422.281 447.14 422.789 447.268 423.197 447.524C423.613 447.78 423.929 448.144 424.145 448.616C424.361 449.088 424.469 449.64 424.469 450.272V450.476C424.469 450.564 424.441 450.632 424.385 450.68C424.337 450.728 424.273 450.752 424.193 450.752H420.041C420.041 450.76 420.041 450.776 420.041 450.8C420.041 450.824 420.041 450.844 420.041 450.86C420.057 451.188 420.129 451.496 420.257 451.784C420.385 452.064 420.569 452.292 420.809 452.468C421.049 452.644 421.337 452.732 421.673 452.732C421.961 452.732 422.201 452.688 422.393 452.6C422.585 452.512 422.741 452.416 422.861 452.312C422.981 452.2 423.061 452.116 423.101 452.06C423.173 451.956 423.229 451.896 423.269 451.88C423.309 451.856 423.373 451.844 423.461 451.844H424.037C424.117 451.844 424.181 451.868 424.229 451.916C424.285 451.956 424.309 452.016 424.301 452.096C424.293 452.216 424.229 452.364 424.109 452.54C423.989 452.708 423.817 452.876 423.593 453.044C423.369 453.212 423.097 453.352 422.777 453.464C422.457 453.568 422.089 453.62 421.673 453.62ZM420.041 449.924H423.329V449.888C423.329 449.528 423.261 449.208 423.125 448.928C422.997 448.648 422.809 448.428 422.561 448.268C422.313 448.1 422.017 448.016 421.673 448.016C421.329 448.016 421.033 448.1 420.785 448.268C420.545 448.428 420.361 448.648 420.233 448.928C420.105 449.208 420.041 449.528 420.041 449.888V449.924ZM428.184 453.62C427.744 453.62 427.364 453.544 427.044 453.392C426.724 453.232 426.46 453.02 426.252 452.756C426.052 452.484 425.9 452.176 425.796 451.832C425.7 451.488 425.644 451.124 425.628 450.74C425.62 450.612 425.616 450.492 425.616 450.38C425.616 450.268 425.62 450.148 425.628 450.02C425.644 449.644 425.7 449.284 425.796 448.94C425.9 448.596 426.052 448.288 426.252 448.016C426.46 447.744 426.724 447.532 427.044 447.38C427.364 447.22 427.744 447.14 428.184 447.14C428.656 447.14 429.048 447.224 429.36 447.392C429.672 447.56 429.928 447.768 430.128 448.016V445.256C430.128 445.176 430.152 445.112 430.2 445.064C430.256 445.008 430.324 444.98 430.404 444.98H430.98C431.06 444.98 431.124 445.008 431.172 445.064C431.228 445.112 431.256 445.176 431.256 445.256V453.224C431.256 453.304 431.228 453.372 431.172 453.428C431.124 453.476 431.06 453.5 430.98 453.5H430.44C430.352 453.5 430.284 453.476 430.236 453.428C430.188 453.372 430.164 453.304 430.164 453.224V452.72C429.964 452.976 429.704 453.192 429.384 453.368C429.064 453.536 428.664 453.62 428.184 453.62ZM428.436 452.648C428.836 452.648 429.156 452.556 429.396 452.372C429.636 452.188 429.816 451.956 429.936 451.676C430.056 451.388 430.12 451.096 430.128 450.8C430.136 450.672 430.14 450.52 430.14 450.344C430.14 450.16 430.136 450.004 430.128 449.876C430.12 449.596 430.052 449.32 429.924 449.048C429.804 448.776 429.62 448.552 429.372 448.376C429.132 448.2 428.82 448.112 428.436 448.112C428.028 448.112 427.704 448.204 427.464 448.388C427.224 448.564 427.052 448.8 426.948 449.096C426.844 449.384 426.784 449.696 426.768 450.032C426.76 450.264 426.76 450.496 426.768 450.728C426.784 451.064 426.844 451.38 426.948 451.676C427.052 451.964 427.224 452.2 427.464 452.384C427.704 452.56 428.028 452.648 428.436 452.648ZM438.91 453.62C438.446 453.62 438.018 453.564 437.626 453.452C437.242 453.332 436.91 453.164 436.63 452.948C436.358 452.724 436.146 452.456 435.994 452.144C435.842 451.832 435.766 451.48 435.766 451.088C435.766 450.6 435.882 450.18 436.114 449.828C436.354 449.476 436.67 449.208 437.062 449.024C436.75 448.84 436.506 448.6 436.33 448.304C436.154 448.008 436.066 447.656 436.066 447.248C436.066 446.768 436.182 446.364 436.414 446.036C436.654 445.7 436.986 445.44 437.41 445.256C437.842 445.072 438.342 444.98 438.91 444.98C439.47 444.98 439.962 445.072 440.386 445.256C440.818 445.432 441.15 445.688 441.382 446.024C441.622 446.36 441.742 446.764 441.742 447.236C441.742 447.644 441.654 448 441.478 448.304C441.302 448.6 441.062 448.84 440.758 449.024C441.15 449.208 441.462 449.476 441.694 449.828C441.934 450.18 442.054 450.6 442.054 451.088C442.054 451.608 441.922 452.06 441.658 452.444C441.394 452.82 441.026 453.112 440.554 453.32C440.082 453.52 439.534 453.62 438.91 453.62ZM438.91 452.66C439.278 452.66 439.61 452.596 439.906 452.468C440.202 452.34 440.438 452.16 440.614 451.928C440.79 451.688 440.878 451.408 440.878 451.088C440.878 450.76 440.79 450.484 440.614 450.26C440.438 450.028 440.202 449.852 439.906 449.732C439.61 449.604 439.278 449.54 438.91 449.54C438.542 449.54 438.206 449.604 437.902 449.732C437.606 449.852 437.37 450.028 437.194 450.26C437.018 450.484 436.93 450.76 436.93 451.088C436.93 451.408 437.018 451.688 437.194 451.928C437.37 452.16 437.606 452.34 437.902 452.468C438.206 452.596 438.542 452.66 438.91 452.66ZM438.91 448.592C439.214 448.592 439.494 448.536 439.75 448.424C440.014 448.312 440.222 448.16 440.374 447.968C440.534 447.776 440.614 447.544 440.614 447.272C440.614 447 440.538 446.764 440.386 446.564C440.242 446.364 440.038 446.212 439.774 446.108C439.518 445.996 439.23 445.94 438.91 445.94C438.59 445.94 438.298 445.996 438.034 446.108C437.778 446.212 437.574 446.364 437.422 446.564C437.27 446.764 437.194 447 437.194 447.272C437.194 447.552 437.27 447.792 437.422 447.992C437.574 448.184 437.778 448.332 438.034 448.436C438.298 448.54 438.59 448.592 438.91 448.592ZM443.899 453.5C443.819 453.5 443.751 453.476 443.695 453.428C443.647 453.372 443.623 453.304 443.623 453.224V445.256C443.623 445.176 443.647 445.112 443.695 445.064C443.751 445.008 443.819 444.98 443.899 444.98H444.499C444.587 444.98 444.655 445.008 444.703 445.064C444.751 445.112 444.775 445.176 444.775 445.256V448.052C444.991 447.78 445.255 447.56 445.567 447.392C445.879 447.224 446.275 447.14 446.755 447.14C447.275 447.14 447.715 447.256 448.075 447.488C448.443 447.712 448.719 448.028 448.903 448.436C449.095 448.836 449.191 449.304 449.191 449.84V453.224C449.191 453.304 449.167 453.372 449.119 453.428C449.071 453.476 449.003 453.5 448.915 453.5H448.315C448.235 453.5 448.167 453.476 448.111 453.428C448.063 453.372 448.039 453.304 448.039 453.224V449.9C448.039 449.34 447.903 448.904 447.631 448.592C447.359 448.272 446.959 448.112 446.431 448.112C445.935 448.112 445.535 448.272 445.231 448.592C444.927 448.904 444.775 449.34 444.775 449.9V453.224C444.775 453.304 444.751 453.372 444.703 453.428C444.655 453.476 444.587 453.5 444.499 453.5H443.899ZM455.605 453.62C455.205 453.62 454.841 453.54 454.513 453.38C454.185 453.22 453.921 453.004 453.721 452.732C453.521 452.46 453.421 452.152 453.421 451.808C453.421 451.256 453.645 450.816 454.093 450.488C454.541 450.16 455.125 449.944 455.845 449.84L457.633 449.588V449.24C457.633 448.856 457.521 448.556 457.297 448.34C457.081 448.124 456.725 448.016 456.229 448.016C455.869 448.016 455.577 448.088 455.353 448.232C455.137 448.376 454.985 448.56 454.897 448.784C454.849 448.904 454.765 448.964 454.645 448.964H454.105C454.017 448.964 453.949 448.94 453.901 448.892C453.861 448.836 453.841 448.772 453.841 448.7C453.841 448.58 453.885 448.432 453.973 448.256C454.069 448.08 454.213 447.908 454.405 447.74C454.597 447.572 454.841 447.432 455.137 447.32C455.441 447.2 455.809 447.14 456.241 447.14C456.721 447.14 457.125 447.204 457.453 447.332C457.781 447.452 458.037 447.616 458.221 447.824C458.413 448.032 458.549 448.268 458.629 448.532C458.717 448.796 458.761 449.064 458.761 449.336V453.224C458.761 453.304 458.733 453.372 458.677 453.428C458.629 453.476 458.565 453.5 458.485 453.5H457.933C457.845 453.5 457.777 453.476 457.729 453.428C457.681 453.372 457.657 453.304 457.657 453.224V452.708C457.553 452.852 457.413 452.996 457.237 453.14C457.061 453.276 456.841 453.392 456.577 453.488C456.313 453.576 455.989 453.62 455.605 453.62ZM455.857 452.72C456.185 452.72 456.485 452.652 456.757 452.516C457.029 452.372 457.241 452.152 457.393 451.856C457.553 451.56 457.633 451.188 457.633 450.74V450.404L456.241 450.608C455.673 450.688 455.245 450.824 454.957 451.016C454.669 451.2 454.525 451.436 454.525 451.724C454.525 451.948 454.589 452.136 454.717 452.288C454.853 452.432 455.021 452.54 455.221 452.612C455.429 452.684 455.641 452.72 455.857 452.72ZM463.042 456.14C462.498 456.14 462.05 456.068 461.698 455.924C461.354 455.78 461.082 455.604 460.882 455.396C460.69 455.196 460.55 454.992 460.462 454.784C460.382 454.584 460.338 454.424 460.33 454.304C460.322 454.224 460.346 454.156 460.402 454.1C460.466 454.044 460.534 454.016 460.606 454.016H461.182C461.254 454.016 461.314 454.032 461.362 454.064C461.41 454.096 461.45 454.164 461.482 454.268C461.53 454.388 461.602 454.52 461.698 454.664C461.794 454.816 461.942 454.944 462.142 455.048C462.342 455.16 462.622 455.216 462.982 455.216C463.358 455.216 463.674 455.164 463.93 455.06C464.186 454.964 464.378 454.788 464.506 454.532C464.642 454.284 464.71 453.94 464.71 453.5V452.684C464.518 452.932 464.266 453.14 463.954 453.308C463.642 453.468 463.25 453.548 462.778 453.548C462.33 453.548 461.946 453.472 461.626 453.32C461.306 453.16 461.042 452.948 460.834 452.684C460.634 452.412 460.482 452.104 460.378 451.76C460.282 451.416 460.226 451.056 460.21 450.68C460.202 450.456 460.202 450.236 460.21 450.02C460.226 449.644 460.282 449.284 460.378 448.94C460.482 448.596 460.634 448.288 460.834 448.016C461.042 447.744 461.306 447.532 461.626 447.38C461.946 447.22 462.33 447.14 462.778 447.14C463.258 447.14 463.654 447.232 463.966 447.416C464.286 447.592 464.546 447.808 464.746 448.064V447.548C464.746 447.468 464.77 447.4 464.818 447.344C464.874 447.288 464.942 447.26 465.022 447.26H465.574C465.654 447.26 465.722 447.288 465.778 447.344C465.834 447.4 465.862 447.468 465.862 447.548V453.368C465.862 453.904 465.77 454.38 465.586 454.796C465.41 455.212 465.114 455.54 464.698 455.78C464.29 456.02 463.738 456.14 463.042 456.14ZM463.018 452.588C463.418 452.588 463.738 452.496 463.978 452.312C464.226 452.128 464.406 451.896 464.518 451.616C464.638 451.336 464.702 451.052 464.71 450.764C464.718 450.652 464.722 450.516 464.722 450.356C464.722 450.188 464.718 450.048 464.71 449.936C464.702 449.648 464.638 449.364 464.518 449.084C464.406 448.804 464.226 448.572 463.978 448.388C463.738 448.204 463.418 448.112 463.018 448.112C462.618 448.112 462.298 448.204 462.058 448.388C461.818 448.564 461.646 448.8 461.542 449.096C461.438 449.384 461.378 449.696 461.362 450.032C461.354 450.24 461.354 450.452 461.362 450.668C461.378 451.004 461.438 451.32 461.542 451.616C461.646 451.904 461.818 452.14 462.058 452.324C462.298 452.5 462.618 452.588 463.018 452.588ZM470.202 453.62C469.594 453.62 469.086 453.504 468.678 453.272C468.27 453.04 467.958 452.72 467.742 452.312C467.526 451.896 467.406 451.424 467.382 450.896C467.374 450.76 467.37 450.588 467.37 450.38C467.37 450.164 467.374 449.992 467.382 449.864C467.406 449.328 467.526 448.856 467.742 448.448C467.966 448.04 468.282 447.72 468.69 447.488C469.098 447.256 469.602 447.14 470.202 447.14C470.802 447.14 471.306 447.256 471.714 447.488C472.122 447.72 472.434 448.04 472.65 448.448C472.874 448.856 472.998 449.328 473.022 449.864C473.03 449.992 473.034 450.164 473.034 450.38C473.034 450.588 473.03 450.76 473.022 450.896C472.998 451.424 472.878 451.896 472.662 452.312C472.446 452.72 472.134 453.04 471.726 453.272C471.318 453.504 470.81 453.62 470.202 453.62ZM470.202 452.696C470.698 452.696 471.094 452.54 471.39 452.228C471.686 451.908 471.846 451.444 471.87 450.836C471.878 450.716 471.882 450.564 471.882 450.38C471.882 450.196 471.878 450.044 471.87 449.924C471.846 449.316 471.686 448.856 471.39 448.544C471.094 448.224 470.698 448.064 470.202 448.064C469.706 448.064 469.306 448.224 469.002 448.544C468.706 448.856 468.55 449.316 468.534 449.924C468.526 450.044 468.522 450.196 468.522 450.38C468.522 450.564 468.526 450.716 468.534 450.836C468.55 451.444 468.706 451.908 469.002 452.228C469.306 452.54 469.706 452.696 470.202 452.696Z'
          fill='#9EA1B1'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_11095_354993'
          x1='321'
          y1='357.5'
          x2='541'
          y2='357.5'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#FF6F26' />
          <stop offset='1' stopColor='#FF66BA' />
        </linearGradient>
        <clipPath id='clip0_11095_354993'>
          <rect
            width='884'
            height='458'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ReadOnlyGraph;
